<template>
  <div class="jobs-revamp jobs-revamp--modern oms-list-page oms-list-page--jobs oms-list-page--compact-table">
    <v-card class="jobs-panel oms-list-panel">
        <section class="jobs-nav-grid oms-list-nav">
          <SegmentedControl
            class="jobs-toggle-group jobs-primary-tabs"
            aria-label="Jobs module view"
            :value="tabStatusMain"
            :options="[
              { label: 'Job View', value: 'Jobs', icon: 'work_outline' },
              {
                label: 'Assignment View',
                value: 'Assignment',
                icon: 'assignment',
              },
            ]"
            @change="redirectTo"
          />

          <SegmentedControl
            class="jobs-toggle-group jobs-toggle-group--right jobs-status-tabs"
            aria-label="Jobs status"
            :value="tabStatus"
            :options="[
              { label: 'Ongoing Jobs', value: 'Ongoing' },
              { label: 'Upcoming Jobs', value: 'Upcoming' },
              { label: 'Past Jobs', value: 'Past' },
            ]"
            @change="filterByJobMainStatus"
          />
        </section>

        <section class="jobs-stats-grid oms-list-stats">
          <article class="jobs-stat-card jobs-stat-card--active oms-list-stat-card">
            <div class="jobs-stat-icon"><v-icon>local_shipping</v-icon></div>
            <span>Active Jobs</span>
            <strong>{{ activeJob }}</strong>
            <small>Open shipment demand</small>
          </article>
          <article class="jobs-stat-card jobs-stat-card--cancelled oms-list-stat-card">
            <div class="jobs-stat-icon"><v-icon>warning</v-icon></div>
            <span>Cancelled Jobs</span>
            <strong>{{ cancelJobs }}</strong>
            <small>Operational exceptions</small>
          </article>
          <article class="jobs-stat-card jobs-stat-card--completed oms-list-stat-card">
            <div class="jobs-stat-icon"><v-icon>check_circle</v-icon></div>
            <span>Completed Jobs</span>
            <strong>{{ completedJob }}</strong>
            <small>Closed shipments</small>
          </article>
          <article class="jobs-stat-card jobs-stat-card--total oms-list-stat-card">
            <div class="jobs-stat-icon"><v-icon>dashboard</v-icon></div>
            <span>Total Jobs</span>
            <strong>{{ totalJob }}</strong>
            <small>All visible jobs</small>
          </article>
        </section>

        <FilterBoard
          class="jobs-filter-panel oms-list-filter"
          :title="`${tabStatus} job queue`"
        >
            <v-flex xs12 sm6 md2 class="jobs-filter-field oms-filter-board__field">
              <v-select
                v-model="searchTypes"
                :items="searchItems"
                flat
                label="Search by"
                item-text="status"
                single-line
                class="pt-0 currencyTitle pppp"
                item-value="abbr"
                persistent-hint
                @change="searchByType()"
                height="10"
                return-object
                outline
              ></v-select>
            </v-flex>
            <v-flex
              xs12
              sm6
              md3
              class="jobs-filter-field jobs-filter-field--search oms-filter-board__field oms-filter-board__field--search"
            >
              <v-text-field
                height="2.5rem"
                class="gap"
                label="Search job ID, company or route..."
                outline
                :disabled="!searchTypes"
                single-line
                v-model="search"
                @keyup.enter="searchAnything"
                @click:append="searchAnything"
                append-icon="search"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs12
              sm6
              md2
              class="jobs-filter-field oms-filter-board__field"
              v-if="this.tabStatus != 'Upcoming'"
            >
              <v-select
                v-model="searchDriverTypes"
                :items="searchDriverItems"
                flat
                label="Driver search by"
                item-text="status"
                single-line
                class="pt-0 currencyTitle pppp"
                item-value="abbr"
                persistent-hint
                @change="searchByDriverType()"
                height="10"
                return-object
                outline
              ></v-select>
            </v-flex>
            <v-flex
              xs12
              sm6
              md2
              class="jobs-filter-field oms-filter-board__field oms-filter-board__field--search"
              v-if="this.tabStatus != 'Upcoming'"
            >
              <v-text-field
                height="2.5rem"
                class="gap"
                label="Search driver or truck..."
                outline
                :disabled="!searchDriverTypes"
                single-line
                v-model="driverSearch"
                @keyup.enter="searchDriverAnything"
                @click:append="searchDriverAnything"
                append-icon="search"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2 class="jobs-filter-field oms-filter-board__field">
              <v-autocomplete
                v-model="select"
                :items="jobStatus"
                multiple
                label="All statuses"
                single-line
                @change="filterByJobStatus"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              xs12
              sm6
              md2
              class="wrapper jobs-filter-field jobs-filter-date oms-filter-board__field oms-filter-board__field--date"
              id="jobDate"
            >
              <ejs-daterangepicker
                :placeholder="waterMark"
                v-model="dateRange2"
              ></ejs-daterangepicker>
            </v-flex>
            <v-flex xs12 sm6 md1 class="jobs-filter-actions oms-filter-board__actions">
              <v-btn
                flat
                class="jobs-reset-link reset-btn-color oms-filter-board__reset oms-btn oms-btn--secondary"
                prepend-icon
                color="orange darken-1"
                @click.native="reset()"
              >
                Reset
              </v-btn>
            </v-flex>
      </FilterBoard>

      <v-card-text class="nospace jobs-table-card oms-list-table-card">
        <ScrollableTable
          class="jobs-table-scroll oms-list-table-scroll"
          min-width="var(--oms-list-table-min-width, 100%)"
        >
          <v-data-table
            id="jobsTable"
            class="jobs-modern-table oms-list-table"
            hide-actions
            :disable-initial-sort="true"
            :pagination.sync="pagination"
            :headers="headers"
            :items="items"
          >
          <template slot="items" slot-scope="props">
            <tr
              :key="props.index"
              :class="[
                'jobs-table-row',
                getDate(props.item.startDate, props.item.pickupTime) <= 12 &&
                getDate(props.item.startDate, props.item.pickupTime) > 6 &&
                (props.item.jobStatus === 3 || props.item.jobStatus === 4)
                  ? 'colorchangeyellow'
                  : '',
                getDate(props.item.startDate, props.item.pickupTime) <= 6 &&
                (props.item.jobStatus === 3 || props.item.jobStatus === 4)
                  ? 'colorchange'
                  : '',
              ]"
            >
              <td data-label="Job ID">
                <div class="jobs-id-cell">
                  <div class="jobs-id-row">
                    <activityLogs
                      :type="'jobs'"
                      :permissions="'activity-logs-jobs'"
                      :_id="props.item._id"
                      :id="props.item.jobId.toString()"
                    />
                    <strong
                      class="jobs-id-value"
                      :title="props.item.jobId.toString()"
                    >
                      {{ props.item.jobId }}
                    </strong>
                  </div>
                </div>
              </td>
              <td data-label="Working Country">
                <span class="jobs-country-pill">
                  <img
                    v-if="props.item.workingCountry == 'PAK'"
                    src="../../assets/pakflag.png"
                    height="20px"
                  /><img
                    v-if="props.item.workingCountry == 'KSA'"
                    src="../../assets/ksaflag.png"
                    height="20px"
                  /><img
                    v-if="props.item.workingCountry == 'UAE'"
                    src="../../assets/Uaeflag.png"
                    height="20px"
                  />
                  <img
                    v-if="props.item.workingCountry == 'UAE LA'"
                    src="../../assets/Uaeflag.png"
                    height="20px"
                  />
                  <img
                    v-if="props.item.workingCountry == 'OMAN'"
                    src="../../assets/omanflag.png"
                    height="20px"
                  />
                  {{ props.item.workingCountry }}
                </span>
              </td>
              <td v-if="props.item.customer" data-label="Company Name">
                <div class="jobs-customer-cell">
                  <strong :title="props.item.companyName || props.item.customer">
                    {{ props.item.companyName || props.item.customer }}
                  </strong>
                  <span :title="props.item.customerEmail || 'Customer account'">
                    {{ props.item.customerEmail || "Customer account" }}
                  </span>
                </div>
              </td>
              <td v-else data-label="Company Name">
                <div class="jobs-customer-cell">
                  <strong :title="props.item.customerEmail || '-'">
                    {{ props.item.customerEmail || "-" }}
                  </strong>
                  <span title="Customer contact">Customer contact</span>
                </div>
              </td>

              <td data-label="No. of trucks">
                <span class="jobs-assignment-total">
                  {{ props.item.numberOfAssignmentsRequired }}
                </span>
              </td>

              <td data-label="Move Date">
                <div class="jobs-date-cell">
                  <v-icon small>event</v-icon>
                  <span>{{ getTime3(props.item.pickupDate) }}</span>
                </div>
              </td>
              <td class="address_td jobs-route-combined-cell jobs-route-column" data-label="Route">
                <div class="jobs-route-pair">
                  <v-tooltip
                    top
                    class="milestone"
                    content-class="tooltip-op"
                    color="orange"
                  >
                    <template slot="activator">
                      <div
                        class="jobs-route-point jobs-route-point--source"
                        :title="`${props.item.sourceCity}, ${props.item.sourceCountry}`"
                      >
                        <span>From</span>
                        <strong>
                          {{ props.item.sourceCity }},
                          {{ props.item.sourceCountry }}
                        </strong>
                      </div>
                    </template>
                    <span class="tooltip">{{ props.item.sourceLocation }}</span>
                  </v-tooltip>
                  <v-tooltip
                    top
                    class="milestone"
                    content-class="tooltip-op"
                    color="orange"
                  >
                    <template slot="activator">
                      <div
                        class="jobs-route-point jobs-route-point--destination"
                        :title="`${props.item.destinationCity}, ${props.item.destinationCountry}`"
                      >
                        <span>To</span>
                        <strong>
                          {{ props.item.destinationCity }},
                          {{ props.item.destinationCountry }}
                        </strong>
                      </div>
                    </template>
                    <span class="tooltip">{{
                      props.item.destinationLocation
                    }}</span>
                  </v-tooltip>
                </div>
              </td>

              <td v-if="props.item.jobStatus == 6" data-label="Assignments">
                <div class="jobs-progress-cell">
                  <div class="jobs-progress-head">
                    <strong>{{ getAssignmentProgressLabel(props.item, "transit") }}</strong>
                    <span>in transit</span>
                  </div>
                  <div class="jobs-progress-track">
                    <span
                      :style="{ width: getAssignmentProgress(props.item, 'transit') + '%' }"
                    ></span>
                  </div>
                  <Assignments
                    v-permissions="'activity-logs-jobs'"
                    :jobId="props.item.jobId"
                  />
                </div>
              </td>
              <td v-else-if="props.item.jobStatus == 7" data-label="Assignments">
                <div class="jobs-progress-cell">
                  <div class="jobs-progress-head">
                    <strong>{{ getAssignmentProgressLabel(props.item, "shipment") }}</strong>
                    <span>POD awaited</span>
                  </div>
                  <div class="jobs-progress-track">
                    <span
                      :style="{ width: getAssignmentProgress(props.item, 'shipment') + '%' }"
                    ></span>
                  </div>
                  <Assignments
                    v-permissions="'activity-logs-jobs'"
                    :jobId="props.item.jobId"
                  />
                </div>
              </td>
              <td v-else-if="props.item.jobStatus == 8" data-label="Assignments">
                <div class="jobs-progress-cell">
                  <div class="jobs-progress-head">
                    <strong>{{ getAssignmentProgressLabel(props.item, "paymentPending") }}</strong>
                    <span>payment pending</span>
                  </div>
                  <div class="jobs-progress-track">
                    <span
                      :style="{ width: getAssignmentProgress(props.item, 'paymentPending') + '%' }"
                    ></span>
                  </div>
                  <Assignments
                    v-permissions="'activity-logs-jobs'"
                    :jobId="props.item.jobId"
                  />
                </div>
              </td>
              <td v-else-if="props.item.jobStatus == 9" data-label="Assignments">
                <div class="jobs-progress-cell">
                  <div class="jobs-progress-head">
                    <strong>{{ getAssignmentProgressLabel(props.item, "paymentDone") }}</strong>
                    <span>paid</span>
                  </div>
                  <div class="jobs-progress-track">
                    <span
                      :style="{ width: getAssignmentProgress(props.item, 'paymentDone') + '%' }"
                    ></span>
                  </div>
                  <Assignments
                    v-permissions="'activity-logs-jobs'"
                    :jobId="props.item.jobId"
                  />
                </div>
              </td>
              <td
                v-else-if="
                  props.item.jobStatus == 5 ||
                  props.item.jobStatus == 4 ||
                  props.item.jobStatus == 1
                "
                data-label="Assignments"
              >
                <div class="jobs-progress-cell">
                  <div class="jobs-progress-head">
                    <strong>{{ getAssignmentProgressLabel(props.item, "Assigned") }}</strong>
                    <span>assigned</span>
                  </div>
                  <div class="jobs-progress-track">
                    <span
                      :style="{ width: getAssignmentProgress(props.item, 'Assigned') + '%' }"
                    ></span>
                  </div>
                  <Assignments
                    v-permissions="'activity-logs-jobs'"
                    :jobId="props.item.jobId"
                  />
                </div>
              </td>
              <td v-else data-label="Assignments">
                <div class="jobs-progress-cell jobs-progress-cell--empty">
                  <span>Assignment log</span>
                  <Assignments
                    v-permissions="'activity-logs-jobs'"
                    :jobId="props.item.jobId"
                  />
                </div>
              </td>

              <td data-label="Status">
                <span
                  class="jobs-status-pill"
                  :class="'jobs-status-pill--' + getJobStatusClass(props.item.jobStatus)"
                  :title="jobsStatus(props.item.jobStatus)"
                >
                  {{ jobsStatus(props.item.jobStatus) }}
                </span>
              </td>

              <td data-label="Action">
                <button
                  v-permissions="'view-details-jobs'"
                  @click="check(props.item.jobId)"
                  target="_blank"
                  :disabled="loading"
                  class="track-ass-btn oms-btn oms-btn--primary"
                >
                  <v-icon small dark>visibility</v-icon>
                  Details
                </button>
              </td>
              <td class="jobs-comments-column" data-label="Comments">
                <CommentCell
                  :comment="
                    props.item.LastCommentTime &&
                    props.item.LastCommentTime.comment
                  "
                >
                  <template slot="action">
                    <SendComments
                      class="oms-comment-cell__action jobs-comment-action"
                      compact-action
                      :userId="props.item.userId"
                      :userName="props.item.customer"
                      :detail="props.item"
                      :type="2"
                      :id="props.item.jobId"
                      v-on:pagination-load="refreshOnComment"
                    />
                  </template>
                </CommentCell>
              </td>
            </tr>
          </template>
          <v-alert
            slot="no-results"
            :value="isNoSearchResult"
            color="blue"
            icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert
          >
          </v-data-table>
        </ScrollableTable>

        <pagination
          :totalPages="totalPage"
          :pages="this.pages"
          @pageNo="page"
          :url="paginationURL"
          :componentKey="componentKey"
          :callback="callback"
          :type="0"
          :action="`job`"
          v-on:pagination-load="checkLoading"
        />
      </v-card-text>
      <v-dialog
        v-model="messageDialog"
        persistent
        :max-width="options.width"
        :style="{ zIndex: options.zIndex }"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-toolbar dark :color="options.color" dense flat>
            <v-toolbar-title style="color: black">{{
              messageTitle
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              :disabled="loading"
              @click.prevent="messageDialog = false"
            >
              <v-icon class="heading grey--text text--darken-4">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-show="!!Message" class="pa-4">
            <v-layout>
              <span class="heading grey--text text--darken-4">{{
                Message
              }}</span>
            </v-layout>
            <v-layout
              class="text--darken-4"
              style="color: lightgrey; font-size: 14px"
              pt-2
            >
              <span
                >By confirmation you allow the system to send the manual command
                to driver</span
              >
            </v-layout>
          </v-card-text>

          <v-card-actions style="padding-bottom: 30px">
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              :disabled="loading"
              flat
              @click="messageDialog = false"
              >NO(CANCEL)</v-btn
            >
            <v-btn
              color="orange darken-1"
              :disabled="loading"
              flat
              @click="sendVoiceMessage"
              >YES(SEND)</v-btn
            >
            <v-snackbar
              :timeout="6000"
              bottom
              color="red darken-2"
              v-model="error"
              class="white--text"
              v-if="error"
              >{{ error }}</v-snackbar
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
        :timeout="6000"
        bottom
        color="red darken-2"
        v-model="error"
        class="white--text"
        v-if="error"
        >{{ error }}</v-snackbar
      >
    </v-card>
  </div>
</template>

<script>
import Bidpopup from "@/components/Procurement/Bidpopup";
import Vue from "vue";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import "moment/locale/fr";
import "moment/locale/es";
import "moment/locale/es"; // without this line it didn't work
moment.locale("en-in");

Vue.use(DateRangePickerPlugin);
import { EventBus } from "../../event-bus.js";
import activityLogs from "../Common/activityLogs";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import _ from "lodash";
import moment from "moment";
let momentTz = require("moment-timezone");
import removeLocalstorageMixin from "@/mixins/removeLocalstorageMixin";
import JobsProfile from "@/components/Jobs/JobDetails/JobsProfile";
import DriverProfileForm from "@/components/Drivers/DriverProfileForm";
import PaginationButtons from "@/components/Pagination/PaginationButtons";
import pagination from "@/components/Pagination/pagination";
import Responsepopup from "@/components/Procurement/Responsepopup";
import SendComments from "@/components/Pop-ups/SendComments";
import CommentCell from "@/components/Common/CommentCell";
import FilterBoard from "@/components/Common/FilterBoard";
import ScrollableTable from "@/components/Common/ScrollableTable";
import SegmentedControl from "@/components/Common/SegmentedControl";
import { jobList } from "@/constants/datatable-headers.js";

import {
  StorageKeys,
  JobListTypes,
  JobGeoType,
  JobMode,
  realBookOrders,
  TruckTypes,
} from "../../constants/constants";
import { async } from "q";
import Assignments from "../Procurement/Assignments";
export default {
  mixins: [removeLocalstorageMixin],
  mounted() {
    if (localStorage.getItem("jobTabStatus") != null) {
      this.tabStatus = localStorage.getItem("jobTabStatus");
      this.statusOnBasisOfTabs(this.tabStatus);
    } else {
      this.tabStatus = "Ongoing";
      this.statusOnBasisOfTabs(this.tabStatus);
    }
  },

  created() {
    // this.removeStorage();
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = JSON.stringify(workingCountry);
      if (localStorage.getItem("paginationUrlJob") !== null) {
        if (localStorage.getItem("jobTabStatus") == "Upcoming") {
          this.searchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
          ];
        } else {
          (this.searchItems = [
            {
              status: "Company Name/Customer Name",
              abbr: "companyName/customerName",
            },
            { status: "Job ID", abbr: "jobId" },
            { status: "Assignment ID", abbr: "assignmentId" },
            { status: "Driver ID", abbr: "id" },
            {
              status: "Driver Name",
              abbr: "name",
            },
            { status: "Truck Number", abbr: "truckNumber" },
          ]),
            (this.searchDriverItems = [
              {
                status: "Company Name/Customer Name",
                abbr: "companyName/customerName",
              },
              { status: "Job ID", abbr: "jobId" },
              { status: "Assignment ID", abbr: "assignmentId" },
              { status: "Driver ID", abbr: "id" },
              {
                status: "Driver Name",
                abbr: "name",
              },
              { status: "Truck Number", abbr: "truckNumber" },
            ]);
        }
        this.updatePaginationUrl();
      } else {
        if (localStorage.getItem("jobTabStatus")) {
          this.tabStatus = localStorage.getItem("jobTabStatus");

          this.paginationURL = `/dmsAdmin/jobList?workingCountry=${
            this.workingCountry
          }&isSearch=false&groupBy=${localStorage.getItem("jobTabStatus")}`;
          this.getJobListCount();
        } else {
          this.paginationURL = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=false&groupBy=Ongoing`;
          this.getJobListCount();
          //this.getJobListCount();
        }
      }
    }

    EventBus.$on("countryChanged", (val) => {
      console.log(val);
      if (this.$route.name == "jobs") {
        this.workingCountry = JSON.stringify(val);
        if (localStorage.getItem("paginationUrlJob") !== null) {
          this.updatePaginationUrl();
        } else {
          if (localStorage.getItem("jobTabStatus")) {
            this.tabStatus = localStorage.getItem("jobTabStatus");

            this.paginationURL = `/dmsAdmin/jobList?workingCountry=${
              this.workingCountry
            }&isSearch=false&groupBy=${localStorage.getItem("jobTabStatus")}`;
            this.getJobListCount();
          } else {
            this.paginationURL = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=false&groupBy=Ongoing`;
            this.getJobListCount();
          }
        }
      }
    });
    this.JobListTypes = JobListTypes;
    this.JobGeoType = JobGeoType;
    this.JobMode = JobMode;
    this.realBookOrders = realBookOrders;
    this.subJobType = [];
    this.subJobMode = [];
    (this.subGeoType = []), (this.subrealBookOrdres = "");
    if (localStorage.getItem("searchJob") !== null) {
      console.log(localStorage.searchJob);
      this.search = localStorage.searchJob;
      this.searchTypes = JSON.parse(localStorage.searchJobType);
      this.loading = false;
    }
    if (localStorage.getItem("searchJobDriver") !== null) {
      this.driverSearch = localStorage.searchJobDriver;
      this.searchDriverTypes = JSON.parse(localStorage.searchJobDriverType);
      this.loading = false;
    }
    // if (
    //   localStorage.getItem("JobstartdateFilter") !== null &&
    //   localStorage.getItem("JobenddateFilter") !== null
    // ) {
    //   this.loading = false;
    //   this.dateRange.startDate = localStorage.getItem("JobstartdateFilter");
    //   this.dateRange.endDate = localStorage.getItem("JobenddateFilter");
    // }
    if (localStorage.getItem("filterType")) {
      this.filtertype.abbr = JSON.parse(localStorage.filterType).abbr;
      this.loading = false;
    }
    if (localStorage.getItem("subJobType")) {
      this.subJobType = JSON.parse(localStorage.getItem("subJobType"));

      this.loading = false;
    }

    if (localStorage.getItem("subGeoType")) {
      this.subGeoType = JSON.parse(localStorage.getItem("subGeoType"));

      this.loading = false;
    }
    if (localStorage.getItem("subJobMode")) {
      this.subJobMode = JSON.parse(localStorage.getItem("subJobMode"));

      this.loading = false;
    }
    if (localStorage.getItem("subRealBook")) {
      this.subrealBookOrdres = localStorage.getItem("subRealBook");
      this.loading = false;
    }

    if (localStorage.getItem("jobStatus") !== null) {
      this.select = JSON.parse(localStorage.jobStatus);
    }
    if (localStorage.getItem("JobstartdateFilter") !== null) {
      this.dateRange2 = JSON.parse(localStorage.JobstartdateFilter);
    }
    // if (localStorage.getItem("JobenddateFilter") !== null) {
    //   this.endDate = localStorage.JobenddateFilter;
    // }

    this.$eventBus.$on("close-job-profile", () => {
      this.dialog = false;
      this.currentItem = null;
    });
  },
  beforeDestroy() {
    this.$eventBus.$off("permission");
  },
  components: {
    DriverProfileForm,
    JobsProfile,
    DateRangePicker,
    PaginationButtons,
    pagination,
    activityLogs,
    Bidpopup,
    FilterBoard,
    CommentCell,
    ScrollableTable,
    SendComments,
    Responsepopup,
    SegmentedControl,
    Assignments,
  },
  watch: {
    dateRange2(val) {
      if (val) {
        if (val[0] && val[1]) {
          this.startDate = moment(val[0]).format("YYYY-MM-DD");
          this.endDate = moment(val[1]).format("YYYY-MM-DD");
        }
        if (this.filtertype.abbr) {
          if (
            !this.subGeoType.length &&
            !this.subJobMode.length &&
            !this.subrealBookOrdres &&
            !this.subJobType.length
          ) {
            this.error = "Please Select the sub filter type ";
            return;
          }
        }
        if (this.endDate && !this.startDate) {
        } else {
          let timezone = momentTz.tz.guess();
          localStorage.setItem("JobstartdateFilter", JSON.stringify(val));
          localStorage.setItem("JobenddateFilter", this.endDate);
          let url = "";

          url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=true&groupBy=${this.tabStatus}&startDate=${this.startDate}&endDate=${this.endDate}`;
          if (this.select.length) {
            url = url + `&status=${JSON.stringify(this.select)}`;
          }
          // if (this.subJobMode.length) {
          //   url = url + `&jobMode=${JSON.stringify(this.subJobMode)}`;
          // }
          // if (this.subGeoType.length) {
          //   url = url + `&jobGeoType=${JSON.stringify(this.subGeoType)}`;
          // }
          // if (this.subJobType.length) {
          //   url = url + `&jobType=${JSON.stringify(this.subJobType)}`;
          // }
          // if (this.subrealBookOrdres.length) {
          //   url = url + `&realBookOrders=${this.subrealBookOrdres}`;
          // }
          if (this.driverSearch) {
            url =
              url +
              `&searchTextTwo=${this.driverSearch}&searchTypeTwo=${this.searchDriverTypes.abbr}`;
          }
          if (this.search.trim().length > 0) {
            url =
              url +
              `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
          }

          this.loading = true;
          this.paginationURL = url;
          this.getJobListCount();
          return;
        }
      } else {
        localStorage.removeItem("JobstartdateFilter");
        localStorage.removeItem("JobenddateFilter");
        this.startDate = "";
        this.endDate = "";
        let url = "";

        url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=true&groupBy=${this.tabStatus}`;
        this.loading = true;
        this.paginationURL = url;
      }
    },
    pagination(val) {
      let temp_url = "";
      if (val["sortBy"] === "numberOfAssignmentsRequired") {
        if (val["descending"] === true) {
          temp_url = "&toSort=truck&sortBy=descending";
          this.updateQueryStringParameter("toSort", "truck");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=truck&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "truck");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (val["sortBy"] === "pickupDate") {
        if (val["descending"] === true) {
          temp_url = "&toSort=date&sortBy=descending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "descending");
        } else if (val["descending"] === false) {
          temp_url = "&toSort=date&sortBy=ascending";
          this.updateQueryStringParameter("toSort", "date");
          this.updateQueryStringParameter("sortBy", "ascending");
        }
      }
      if (!val["sortBy"]) {
        this.removeParam(["toSort", "sortBy"]);
      }
      this.updateQueryStringParameter("isSearch", "true");
      deep: true;
    },
  },

  data() {
    return {
      componentKey: 0,
      picker: {},
      local_param: {
        timeRange: 1,
      },
      pagination: {},
      index: null,
      tabStatus: "Ongoing",
      tabStatusMain: "Jobs",
      operation: "",
      operationName: "",
      type: false,
      options: {
        color: "rgb(245, 245, 245)",
        width: 600,
        zIndex: 200,
      },
      jobId: "",
      messageDialog: false,
      messageTitle: "Are your sure?",
      Message: "Confirm that you want to send the message",
      dateRange: { startDate: "", endDate: "" },
      workingCountry: [],
      JobListTypes: [],
      subJobType: [],
      JobMode: [],
      subJobMode: [],
      JobGeoType: [],
      subGeoType: [],
      realBookOrders: [],
      subrealBookOrdres: "",

      disable: false,
      dateToday: moment(new Date()).format("YYYY/MM/DD HH:mm"),
      pages: 1,

      FilterDateBool: false,
      FilterEndDateBool: false,
      endDate: "",
      error: null,
      paginationURL: "",
      startDate: "",
      select: [],
      filtertype: { status: "", abbr: "" },
      jobStatus: [
        { text: "Active", value: "active" },
        { text: "Customer Rate Accepted", value: "customerRateAccepted" },
        { text: "Driver Partially Assign.", value: "driverPartially" },
        { text: "Finding Drivers", value: "findingDrivers" },
        { text: "Driver Assigned", value: "driverAssigned" },
        { text: "In Transit", value: "inTransit" },
        {
          text: "Shipment Offloaded & POD Awaited",
          value: "shipmentOffloaded",
        },
        { text: "Document Received", value: "Doc Received" },
        { text: "Payment Pending", value: "paymentPending" },
        { text: "Payment Done", value: "paymentDone" },
        { text: "Completed", value: "completed" },
        { text: "Cancelled", value: "cancel" },
      ],
      jobFilter: [
        { status: "Job Type", abbr: "jobType" },
        { status: "Job Mode", abbr: "jobMode" },
        { status: "Job Geo Type", abbr: "jobGeoType" },
        { status: "Account", abbr: "account" },
        // { status: "Booking", abbr: "Booking" },
      ],
      searchItems: [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        { status: "Driver ID", abbr: "id" },
        {
          status: "Driver Name",
          abbr: "name",
        },
        { status: "Truck Number", abbr: "truckNumber" },
      ],
      searchDriverItems: [
        {
          status: "Company Name/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Job ID", abbr: "jobId" },
        { status: "Assignment ID", abbr: "assignmentId" },
        { status: "Driver ID", abbr: "id" },
        {
          status: "Driver Name",
          abbr: "name",
        },
        { status: "Truck Number", abbr: "truckNumber" },
      ],
      searchTypes: "",
      searchDriverTypes: "",
      status: [],
      executive: "",
      search: "",
      driverSearch: "",
      driverSearch: "",
      activeJob: 0,
      cancelJobs: 0,
      completedJob: 0,
      totalJob: 0,
      totalDatas: 0,
      waterMark: "Select a Range",
      dateRange2: null,
      totalPage: 0,
      isNoSearchResult: false,
      loading: false,
      server: false,
      headers: jobList,
      items: [],
    };
  },
  methods: {
    redirectTo(type) {
      if (type === "Jobs") {
        this.$router.push(`/jobs`);
      } else {
        this.$router.push(`/assignments`);
      }
    },
    updateQueryStringParameter(key, value) {
      var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      var separator = this.paginationURL.indexOf("?") !== -1 ? "&" : "?";
      if (this.paginationURL.match(re)) {
        this.paginationURL = this.paginationURL.replace(
          re,
          "$1" + key + "=" + value + "$2"
        );
      } else {
        this.paginationURL = this.paginationURL + separator + key + "=" + value;
      }
    },

    removeParam(keys) {
      let sourceURL = localStorage.getItem("paginationUrlJob");
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (keys.indexOf(param) >= 0) {
            params_arr.splice(i, 1);
          }
        }
        rtn = rtn + "?" + params_arr.join("&");
      }
      this.paginationURL = rtn;
    },

    statusOnBasisOfTabs(tab) {
      this.jobStatus = [];
      if (tab == "Ongoing") {
        this.jobStatus = [
          { text: "Driver Assigned", value: "driverAssigned" },
          { text: "Driver Partially Assign.", value: "driverPartially" },
          { text: "In Transit", value: "inTransit" },
        ];
      } else if (tab == "Upcoming") {
        this.jobStatus = [
          { text: "Active", value: "active" },
          { text: "Customer Rate Accepted", value: "customerRateAccepted" },

          { text: "Finding Drivers", value: "findingDrivers" },
          { text: "Driver Assigned", value: "driverAssigned" },
        ];
      } else if (tab == "Past") {
        this.jobStatus = [
          { text: "Shipment Offloaded", value: "shipmentOffloaded" },
          { text: "Payment Pending", value: "paymentPending" },
          { text: "Payment Done", value: "paymentDone" },
          { text: "Completed", value: "completed" },
          { text: "Cancelled", value: "cancel" },
        ];
      } else {
        this.jobStatus = [
          { text: "Active", value: "active" },
          { text: "Customer Rate Accepted", value: "customerRateAccepted" },
          { text: "Driver Partially Assign.", value: "driverPartially" },
          { text: "Finding Drivers", value: "findingDrivers" },
          { text: "Driver Assigned", value: "driverAssigned" },
          { text: "In Transit", value: "inTransit" },
          { text: "Shipment Offloaded", value: "shipmentOffloaded" },
          { text: "Payment Pending", value: "paymentPending" },
          { text: "Payment Done", value: "paymentDone" },
          { text: "Completed", value: "completed" },
          { text: "Cancelled", value: "cancel" },
        ];
      }
    },
    async check(jobId) {
      this.operationName = "view-details-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.$router.push(`/jobs/${jobId}`);
      } else {
        return;
      }
    },
    isOnlyLand(type) {
      if (type) {
        var count = {};
        var string = "";
        type.forEach(function (i) {
          count[i] = (count[i] || 0) + 1;
        });
        if (count["1"] > 1 || count["3"] > 0 || count["2"] > 0) {
          return false;
        } else {
          return true;
        }
      }
    },

    getJobId(number, currentIndex) {
      this.jobId = number;
      this.messageDialog = true;
      this.index = currentIndex;
    },
    sendVoiceMessage() {
      this.loading = true;
      this.$emit("job-load", true);
      let Url = "/dmsAdmin/sendWhatsAppToDriversForNewJob";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };

      let body = {
        jobId: this.jobId.toString(),
      };
      this.axios.post(this.constants.apiUrl + Url, body, config).then(
        (response) => {
          this.loading = false;
          this.$emit("job-load", false);
          this.messageDialog = false;
          this.items[this.index].isWhatsAppSent = true;
        },
        (error) => {
          this.loading = false;
          this.$emit("job-load", false);
          this.error = error.response.data.message;
          setTimeout(() => {
            this.error = "";
          }, 6000);
        }
      );
    },
    refreshOnComment() {
      this.componentKey++;
    },
    // clickCancel() {
    //   if (this.open) {
    //     // reset start and end
    //     let startDate = this.dateRange.startDate;
    //     let endDate = this.dateRange.endDate;
    //     this.start = startDate ? new Date(startDate) : null;
    //     this.end = endDate ? new Date(endDate) : null;
    //     // this.open = false
    //     this.togglePicker(false, true);
    //   }
    // },
    updatePaginationUrl() {
      let tempUrl = localStorage.getItem("paginationUrlJob");
      let x = tempUrl.split("&");
      let y = x[0].split("=");
      y[1] = this.workingCountry;
      x[0] = y.join("=");
      tempUrl = x.join("&");

      this.paginationURL = tempUrl;
      this.getJobListCount();
    },
    getText(arr = [], val) {
      let finalEl = null;

      finalEl = arr.find((el) => el.value === val.toString());

      return finalEl ? finalEl.text : "NA";
    },
    emptySub() {
      this.subJobMode = [];
      this.subJobType = [];
      this.subGeoType = [];
      this.subrealBookOrdres = "";
    },
    getJobTypeWithCount(type) {
      var stringAir = "";
      var stringSea = "";
      var stringLand = "";
      if (type) {
        var count = {};
        var string = "";
        type.forEach(function (i) {
          count[i] = (count[i] || 0) + 1;
        });
        if (count["2"] > 0) {
          stringAir = "  Air-" + count["2"];
          this.type = false;
        }
        if (count["3"] > 0) {
          stringSea = "  Sea-" + count["3"];
          this.type = false;
        }
        if (count["1"] > 0) {
          stringLand = " Land-" + count["1"];
          this.type = true;
        }
        if (stringAir.length > 0 || stringSea.length > 0) {
          stringLand = stringLand.length > 0 ? stringLand + "," : stringLand;
        }
        if (stringSea.length > 0) {
          stringAir = stringAir.length > 0 ? stringAir + "," : stringAir;
        }
      } else {
        return;
      }
    },
    getJobTypeValue(value) {
      switch (value) {
        case "1":
          return "Land";
        case "2":
          return "Air";
        case "3":
          return "Sea";
        default:
          return "Land";
      }
    },
    page(event) {
      this.pages = event;
    },

    searchHistory() {
      if (localStorage.getItem("searchText") !== null) {
      }
    },
    bidSuccess(event) {},
    refreshBid(event) {
      this.paginationURL = this.paginationURL;
      for (var i = 0; i < this.items.length; i++) {
        if (event.jobId === this.items[i].jobId) {
          this.items[i].isTransporterJob = true;
        }
      }
    },
    searchByType() {
      this.$emit("filters-type", this.searchTypes.abbr);
      if (this.searchTypes.abbr) {
        this.searchDriverItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];

        this.searchDriverItems.forEach((k) => {
          if (k["abbr"] == this.searchTypes.abbr) {
            let elementPos = this.searchDriverItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.searchDriverItems.splice(elementPos, 1);
          }
        });
      }

      if (this.searchDriverTypes.abbr) {
      }

      if (
        (this.searchTypes && this.search.trim().length > 0) ||
        this.select.length ||
        this.driverSearch.trim().length > 0 ||
        this.startDate
      ) {
        this.search = "";
        // this.searchAnything();
      }
    },
    searchByDriverType() {
      // this.$emit("filters-driver-type", this.searchDriverTypes.abbr);
      if (this.searchDriverTypes.abbr) {
        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];

        this.searchItems.forEach((k) => {
          if (k["abbr"] == this.searchDriverTypes.abbr) {
            let elementPos = this.searchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.searchItems.splice(elementPos, 1);
          }
        });
      }
      if (
        (this.searchDriverTypes && this.driverSearch.trim().length > 0) ||
        this.select.length ||
        this.search.trim().length > 0 ||
        this.startDate
      ) {
        this.driverSearch = "";
        // this.searchDriverAnything();
      }
    },
    goToProfile(jobId) {
      this.$router.push(`/jobs/${jobId}`);
    },
    getTime3(date) {
      return moment.utc(date).format("ll");
    },
    getTime4(date) {
      return moment(date).format("ll LT");
    },
    getCommentPreview(comment) {
      if (!comment || comment === " ") {
        return "";
      }
      if (comment.length > 42) {
        return comment.substring(0, 42) + "...";
      }
      return comment;
    },
    getAssignmentProgressLabel(item, field) {
      let done = parseInt(item[field] || 0);
      let total = parseInt(item.numberOfAssignmentsRequired || 0);
      return done + "/" + total;
    },
    getAssignmentProgress(item, field) {
      let done = parseInt(item[field] || 0);
      let total = parseInt(item.numberOfAssignmentsRequired || 0);
      if (!total) {
        return 0;
      }
      let progress = Math.round((done / total) * 100);
      if (progress > 100) {
        return 100;
      }
      return progress;
    },
    getJobStatusClass(status) {
      switch (status) {
        case 1:
        case 3:
        case 4:
          return "open";
        case 5:
        case 6:
        case 7:
          return "moving";
        case 8:
          return "pending";
        case 9:
        case 2:
          return "done";
        case -1:
          return "cancelled";
        default:
          return "neutral";
      }
    },
    getDate(startdate, time) {
      var test = moment.unix(startdate).format("YYYY/MM/DD") + " " + time;

      var diff = Math.abs(new Date(test) - new Date(this.dateToday)); // hours
      var minutes = Math.floor(diff / 1000 / 60);
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var difference =
        (new Date(test).getTime() - new Date(this.dateToday).getTime()) / 1000;
      difference /= 60 * 60;
      return Math.abs(Math.round(difference));
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Active";
        case 2:
          return "Completed";
        case 3:
          return "Customer Rate Accepted";
        case 4:
          return "Finding Drivers";
        case 5:
          return "Driver Assigned";
        case 6:
          return "In-Transit";
        case 7:
          return "Shipment Offloaded & POD Awaited";
        case 8:
          return "Payment Pending";
        case 9:
          return "Payment Done";
        case 10:
          return "Low Credit Limit";

        case -1:
          return "Cancelled";
        default:
          return "Unknown";
      }
    },
    checkLoading(event) {
      if (event) {
        this.$emit("job-load", true);
      } else {
        this.$emit("job-load", false);
        this.loading = false;
      }
    },
    async searchFilter() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      }

      if (this.endDate && !this.startDate) {
      } else {
        let timezone = momentTz.tz.guess();
        let url = "";
        localStorage.setItem("filterType", JSON.stringify(this.filtertype));
        if (this.filtertype.abbr == "jobType") {
          localStorage.setItem("subJobType", JSON.stringify(this.subJobType));
          url = `/dmsAdmin/jobList?workingCountry=${
            this.workingCountry
          }&groupBy=${this.tabStatus}&jobType=${JSON.stringify(
            this.subJobType
          )}&isSearch=true`;
        }
        if (this.filtertype.abbr == "jobMode") {
          localStorage.setItem("subJobMode", JSON.stringify(this.subJobMode));
          url = `/dmsAdmin/jobList?workingCountry=${
            this.workingCountry
          }&groupBy=${this.tabStatus}&jobMode=${JSON.stringify(
            this.subJobMode
          )}&isSearch=true`;
        }
        if (this.filtertype.abbr == "account") {
          localStorage.setItem("subRealBook", this.subrealBookOrdres);
          url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=true&groupBy=${this.tabStatus}&realBookOrders=${this.subrealBookOrdres}`;
        }
        if (this.filtertype.abbr == "jobGeoType") {
          localStorage.setItem("subGeoType", JSON.stringify(this.subGeoType));
          url = `/dmsAdmin/jobList?workingCountry=${
            this.workingCountry
          }&groupBy=${this.tabStatus}&jobGeoType=${JSON.stringify(
            this.subGeoType
          )}`;
        }
        if (this.startDate)
          url = `&startDate=${this.startDate}&endDate=${this.endDate}`;
        if (this.select.length) {
          url = url + `&status=${JSON.stringify(this.select)}`;
        }
        if (this.driverSearch.trim().length > 0) {
          url =
            url +
            `&searchTextTwo=${this.driverSearch}&searchTypeTwo=${this.searchDriverTypes.abbr}`;
        }
        if (this.search.trim().length > 0) {
          url =
            url +
            `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
        }
        this.loading = true;
        this.paginationURL = url;
        this.getJobListCount();
        return;
      }
    },
    async searchAnything() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      }
      if (this.filtertype.abbr) {
        if (
          !this.subGeoType.length &&
          !this.subJobMode.length &&
          !this.subrealBookOrdres &&
          !this.subJobType.length
        ) {
          this.error = "Please Select the sub filter type ";
          return;
        }
      }
      let timezone = momentTz.tz.guess();

      this.$eventBus.$emit("searchJob", this.search);

      // ------------ checking if search text exists ot not
      let url = "";

      if (this.search.trim().length > 0) {
        localStorage.setItem("searchJob", this.search.trim());
        localStorage.setItem("searchJobType", JSON.stringify(this.searchTypes));
        url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&groupBy=${this.tabStatus}&isSearch=true&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
      } else {
        // url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&groupBy=${this.tabStatus}&isSearch=true`;
        // url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&groupBy=${this.tabStatus}&isSearch=true&searchType=${this.searchTypes.abbr}`;
      }

      if (this.startDate) {
        url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
      }
      if (this.select.length) {
        url = url + `&status=${JSON.stringify(this.select)}`;
      }
      if (this.driverSearch.trim().length > 0) {
        url =
          url +
          `&searchTextTwo=${this.driverSearch}&searchTypeTwo=${this.searchDriverTypes.abbr}`;
      }

      // ----------- checking other filters and adding respectively to url
      // if (this.startDate) {
      //   url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
      // }
      // if (this.select.length) {
      //   url = url + `&status=${JSON.stringify(this.select)}`;
      // }
      // if (this.driverSearch) {
      //   url =
      //     url +
      //     `&driverSearchText=${this.driverSearch}&driverSearchType=${this.searchDriverTypes.abbr}`;
      // }
      // if (this.subJobMode.length) {
      //   url = url + `&jobMode=${JSON.stringify(this.subJobMode)}`;
      // }
      // if (this.subGeoType.length) {
      //   url = url + `&jobGeoType=${JSON.stringify(this.subGeoType)}`;
      // }
      // if (this.subJobType.length) {
      //   url = url + `&jobType=${JSON.stringify(this.subJobType)}`;
      // }
      // if (this.subrealBookOrdres.length) {
      //   url = url + `&realBookOrders=${this.subrealBookOrdres}`;
      // }
      this.loading = true;
      this.paginationURL = url;
      console.log(this.search.trim().length > 0);
      if (this.search.trim().length > 0) {
        this.getJobListCount();
      }
      return;
    },
    async searchDriverAnything() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      }
      //   let timezone = momentTz.tz.guess();
      // localStorage.setItem("searchJobDriver", this.driverSearch);
      // localStorage.setItem(
      //   "searchJobDriverType",
      //   JSON.stringify(this.searchDriverTypes)
      // );
      // ------------ checking if search text exists ot not
      let url = "";
      if (this.driverSearch.trim().length > 0) {
        localStorage.setItem("searchJobDriver", this.driverSearch);
        localStorage.setItem(
          "searchJobDriverType",
          JSON.stringify(this.searchDriverTypes)
        );
        url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&groupBy=${this.tabStatus}&isSearch=true&searchTextTwo=${this.driverSearch}&searchTypeTwo=${this.searchDriverTypes.abbr}`;
      } else {
        // url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&groupBy=${this.tabStatus}&isSearch=true`;
      }
      // ----------- checking other filters and adding respectively to url
      if (this.startDate) {
        url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
      }
      if (this.select.length) {
        url = url + `&status=${JSON.stringify(this.select)}`;
      }
      if (this.search) {
        url =
          url +
          `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
      }

      this.loading = true;
      this.paginationURL = url;

      this.getJobListCount();
      return;
    },
    async filterByJobStatus() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      }
      if (this.filtertype.abbr) {
        if (
          !this.subGeoType.length &&
          !this.subJobMode &&
          !this.subrealBookOrdres &&
          !this.subJobType.length
        ) {
          this.error = "Please Select the sub filter type ";
          return;
        }
      }
      if (this.endDate && !this.startDate) {
      } else {
        let timezone = momentTz.tz.guess();
        localStorage.setItem("jobStatus", JSON.stringify(this.select));
        let url = `/dmsAdmin/jobList?workingCountry=${
          this.workingCountry
        }&isSearch=true&status=${JSON.stringify(this.select)}&groupBy=${
          this.tabStatus
        }`;
        if (this.driverSearch) {
          url =
            url +
            `&searchTextTwo=${this.driverSearch}&searchTypeTwo=${this.searchDriverTypes.abbr}`;
        }
        if (this.startDate) {
          url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
        }
        // if (this.subJobMode.length) {
        //   url = url + `&jobMode=${JSON.stringify(this.subJobMode)}`;
        // }
        // if (this.subGeoType.length) {
        //   url = url + `&jobGeoType=${JSON.stringify(this.subGeoType)}`;
        // }
        // if (this.subJobType.length) {
        //   url = url + `&jobType=${JSON.stringify(this.subJobType)}`;
        // }
        // if (this.subrealBookOrdres.length) {
        //   url = url + `&realBookOrders=${this.subrealBookOrdres}`;
        // }
        if (this.search) {
          url =
            url +
            `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
        }
        this.loading = true;
        this.paginationURL = url;
        if (this.driverSearch.trim().length > 0 || this.select) {
          this.getJobListCount();
        }
        return;
      }
    },
    async filterByJobMainStatus(tabStatus) {
      this.tabStatus = tabStatus;
      this.pagination.sortBy = null;
      this.pagination.descending = null;
      this.select = [];
      localStorage.removeItem("jobStatus");
      this.statusOnBasisOfTabs(tabStatus);
      if (tabStatus == "Upcoming") {
        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
        ];
      } else {
        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];

        this.searchItems.forEach((k) => {
          if (k["abbr"] == this.searchDriverTypes.abbr) {
            let elementPos = this.searchItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.searchItems.splice(elementPos, 1);
          }
        });

        this.searchDriverItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];

        this.searchDriverItems.forEach((k) => {
          if (k["abbr"] == this.searchTypes.abbr) {
            let elementPos = this.searchDriverItems
              .map(function (x) {
                return x.abbr;
              })
              .indexOf(k["abbr"]);

            this.searchDriverItems.splice(elementPos, 1);
          }
        });
      }

      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      }
      if (this.filtertype.abbr) {
        if (
          !this.subGeoType.length &&
          !this.subJobMode &&
          !this.subrealBookOrdres &&
          !this.subJobType.length
        ) {
          this.error = "Please Select the sub filter type ";
          return;
        }
      }
      if (this.endDate && !this.startDate) {
      } else {
        let timezone = momentTz.tz.guess();
        localStorage.setItem("jobTabStatus", tabStatus);
        let url = "";

        url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=true&groupBy=${tabStatus}`;
        if (this.startDate) {
          url = url + `&startDate=${this.startDate}&endDate=${this.endDate}`;
        }
        if (this.select.length) {
          url = url + `&status=${JSON.stringify(this.select)}`;
        }
        if (this.driverSearch) {
          if (tabStatus != "Upcoming") {
            url =
              url +
              `&searchTextTwo=${this.driverSearch}&searchTypeTwo=${this.searchDriverTypes.abbr}`;
          } else {
            this.driverSearch = "";
            this.searchDriverTypes = "";
          }
        }
        // if (this.subJobMode.length) {
        //   url = url + `&jobMode=${JSON.stringify(this.subJobMode)}`;
        // }
        // if (this.subGeoType.length) {
        //   url = url + `&jobGeoType=${JSON.stringify(this.subGeoType)}`;
        // }
        // if (this.subJobType.length) {
        //   url = url + `&jobType=${JSON.stringify(this.subJobType)}`;
        // }
        // if (this.subrealBookOrdres.length) {
        //   url = url + `&realBookOrders=${this.subrealBookOrdres}`;
        // }
        if (this.search.trim().length > 0) {
          url =
            url +
            `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
        }
        this.loading = true;
        this.paginationURL = url;
        this.getJobListCount();
        return;
      }
    },
    async startDateFilter() {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
      }
      if (this.filtertype.abbr) {
        if (
          !this.subGeoType.length &&
          !this.subJobMode.length &&
          !this.subrealBookOrdres &&
          !this.subJobType.length
        ) {
          this.error = "Please Select the sub filter type ";
          return;
        }
      }

      let timezone = momentTz.tz.guess();
      localStorage.setItem("JobstartdateFilter", this.dateRange.startDate);
      localStorage.setItem("JobenddateFilter", this.dateRange.endDate);
      let url = "";
      if (this.startDate)
        url = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=true&groupBy=${this.tabStatus}&startDate=${this.startDate}&endDate=${this.endDate}`;
      if (this.select.length) {
        url = url + `&status=${JSON.stringify(this.select)}`;
      }
      if (this.subJobMode.length) {
        url = url + `&jobMode=${JSON.stringify(this.subJobMode)}`;
      }
      if (this.subGeoType.length) {
        url = url + `&jobGeoType=${JSON.stringify(this.subGeoType)}`;
      }
      if (this.subJobType.length) {
        url = url + `&jobType=${JSON.stringify(this.subJobType)}`;
      }
      if (this.subrealBookOrdres.length) {
        url = url + `&realBookOrders=${this.subrealBookOrdres}`;
      }
      if (this.driverSearch) {
        url =
          url +
          `&searchTextTwo=${this.driverSearch}&searchTypeTwo=${this.searchDriverTypes.abbr}`;
      }
      if (this.search) {
        url =
          url +
          `&searchText=${this.search}&searchType=${this.searchTypes.abbr}`;
      }
      this.loading = true;
      this.paginationURL = url;
      this.getJobListCount();
      return;
    },

    reset() {
      if (localStorage.getItem("jobTabStatus") == "Upcoming") {
        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
        ];
      } else {
        this.searchItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];

        this.searchDriverItems = [
          {
            status: "Company Name/Customer Name",
            abbr: "companyName/customerName",
          },
          { status: "Job ID", abbr: "jobId" },
          { status: "Assignment ID", abbr: "assignmentId" },
          { status: "Driver ID", abbr: "id" },
          {
            status: "Driver Name",
            abbr: "name",
          },
          { status: "Truck Number", abbr: "truckNumber" },
        ];
      }

      this.pagination.sortBy = null;
      this.pagination.descending = null;
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
      this.dateRange2 = null;
      localStorage.removeItem("paginationUrlJob");
      localStorage.removeItem("searchJob");
      localStorage.removeItem("searchJobDriver");
      localStorage.removeItem("searchJobType");
      localStorage.removeItem("searchJobDriverType");
      localStorage.removeItem("subRealBook");
      localStorage.removeItem("subJobType");
      localStorage.removeItem("filterType");
      localStorage.removeItem("subGeoType");
      localStorage.removeItem("subJobMode");
      localStorage.removeItem("jobStatus");
      localStorage.removeItem("JobstartdateFilter");
      localStorage.removeItem("JobenddateFilter");
      this.startDate = "";
      this.endDate = "";
      this.select = [];
      this.status = "";
      this.executive = "";
      this.filtertype = "";
      this.subGeoType = [];
      this.subJobMode = [];
      this.subJobType = [];
      this.searchTypes = "";
      this.searchDriverTypes = "";
      this.driverSearch = "";
      this.subrealBookOrdres = "";
      this.search = "";
      this.paginationURL = `/dmsAdmin/jobList?workingCountry=${this.workingCountry}&isSearch=false&groupBy=${this.tabStatus}`;
      this.getJobListCount();
      return;
    },
    getJobListCount() {
      let v = {};
      this.loading = true;
      let Url = "/dmsAdmin/jobListCount";

      let temp_url = this.paginationURL;
      Url = "/dmsAdmin/jobListCount?" + temp_url.split("?")[1];
      let body = {};
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      this.axios.defaults.headers.common["authorization"] = `bearer ${token}`;

      v = this.axios.get(this.constants.apiUrl + Url, body).then(
        (response) => {
          this.loading = false;
          this.jobCount = response.data.data;
          let countData = this.jobCount;
          this.activeJob = countData.activeJobs;
          this.cancelJobs = countData.cancelJobs;
          this.completedJob = countData.completedJobs;
          this.totalJob = countData.totalJobs;
          this.totalDatas = countData.totalData;
          this.totalPage = Math.ceil(this.totalDatas / 15);
        },
        (error) => {}
      );
      return v;
    },
    async callback({
      jobInfo,
      activeJobs,
      totalJobs,
      completedJobs,
      totalData,
      cancelJobs,
    }) {
      this.items = jobInfo;
      //  this.getJobListCount();
      this.loading = false;
      this.items.forEach((element) => {
        if (!element.isTransporterJob) element.isTransporterJob = false;
      });
      this.$emit("job-load", false);
      window.scrollTo(0, 0);
      this.pagination.rowsPerPage = 15;
    },
  },
};
</script>

<style lang="scss">
.jobs-revamp #jobDate .e-input-group-icon.e-range-icon.e-icons::after {
  content: none !important;
}

.jobs-revamp #jobDate span.e-input-group-icon.e-range-icon.e-icons {
  flex: 0 0 auto;
  justify-content: center;
  min-width: 1.5rem;
  width: 1.5rem;
}
.jobs-revamp #jobDate .e-input-group-icon.e-range-icon::before,
.jobs-revamp .e-control-wrapper .e-input-group-icon.e-range-icon::before {
  content: "\e245";
  font-family: "e-icons";
}
.jobs-revamp #jobDate .e-input-group input.e-input {
  flex: 1 1 auto;
  padding-left: 0 !important;
}
.jobs-revamp #jobDate .e-daterangepicker {
  left: inherit !important;
  right: 120px;
}
.jobs-revamp .e-daterangepicker.e-popup .e-calendar,
.jobs-revamp .e-bigger.e-small .e-daterangepicker.e-popup .e-calendar {
  background-color: #fff;
  height: 100%;
}
.jobs-revamp #jobDate .e-clear-icon {
  display: none !important;
  opacity: 0;
}

.jobs-revamp #jobsTable .theme--light.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
  color: white !important;
  margin-left: 10px !important;
}
.jobs-revamp #jobsTable .theme--light.v-datatable thead th.column.sortable.active .v-icon {
  opacity: 1 !important;
  color: white !important;
  margin-left: 10px !important;
}
.jobs-revamp .daterangepicker.openscenter[data-v-267f4ee2] {
  position: absolute;
  top: 35px;
  left: 80%;
}
.jobs-revamp .reportrange-text[data-v-267f4ee2] {
  background: #fff;
  cursor: pointer;
  position: absolute;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #ccc;
  padding: 5px 10px;
  width: 250px;
}

.jobs-revamp .drp-calendar {
  margin-right: 80px !important;
}

.jobs-revamp .daterangepicker.openscenter[data-v-267f4ee2] {
  right: auto;
  left: 62%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
.jobs-revamp .tooltip-op-comment {
  /* left: calc(100% - 20.2%) !important; */
  max-width: 15%;
  opacity: 1 !important;
}
.jobs-revamp .minHeight {
  min-height: 300px;
}
.jobs-revamp .card--raised {
  border: 1px solid orange !important;
}

.jobs-revamp #jobDate {
  padding-top: 18px;
}
.jobs-revamp .address_td {
  overflow-wrap: break-word;
  word-break: normal;
}
.jobs-revamp td {
  font-size: 16px !important;
}

.jobs-revamp {
  --jobs-bg: #f6f5f2;
  --jobs-panel: #ffffff;
  --jobs-ink: #3a382f;
  --jobs-navy: #1a1916;
  --jobs-muted: #74716a;
  --jobs-primary: #ea7a1c;
  --jobs-primary-dark: #d96a10;
  --jobs-primary-soft: #fdf0e4;
  --jobs-border: #e4e1d9;
  --jobs-row: #ffffff;
  --jobs-shadow: 0 18px 45px rgba(26, 25, 22, 0.08);
  background: var(--jobs-bg);
  padding: 4px;
}

.jobs-panel {
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: var(--jobs-shadow) !important;
  overflow: hidden;
}

.jobs-kicker,
.jobs-section-title span {
  color: var(--jobs-primary-dark);
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.jobs-section-title h2 {
  color: var(--jobs-ink);
  font-weight: 700;
  letter-spacing: 0;
  margin: 0;
}

.jobs-tab {
  border: 0;
  cursor: pointer;
  font-family: inherit;
  letter-spacing: 0;
  outline: none;
}

.jobs-nav-grid {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #f0eee8;
  display: grid;
  gap: 12px;
  grid-template-columns: var(
    --oms-list-nav-columns,
    minmax(260px, 0.5fr) minmax(360px, 1fr)
  );
  padding: var(--oms-list-section-y, 12px) var(--oms-list-section-x, 30px);
}

.jobs-toggle-group {
  background: #f4f3ee;
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  display: flex;
  flex-wrap: nowrap !important;
  gap: 6px;
  max-width: 100%;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  padding: 5px;
  width: fit-content;
}

.jobs-toggle-group--right {
  justify-self: end;
}

.jobs-tab {
  align-items: center;
  background: transparent;
  border-radius: 7px;
  color: var(--jobs-muted);
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 6px;
  justify-content: center;
  min-height: 32px;
  padding: 7px 12px;
  white-space: nowrap;
}

.jobs-tab--active {
  background: var(--jobs-panel);
  box-shadow: 0 5px 16px rgba(26, 25, 22, 0.08);
  color: var(--jobs-primary-dark);
}

.jobs-stats-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: var(--oms-list-stat-columns, repeat(4, minmax(0, 1fr)));
  padding: var(--oms-list-section-y, 14px) var(--oms-list-section-x, 30px);
}

.jobs-stat-card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.94), #ffffff),
    var(--jobs-row);
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(26, 25, 22, 0.04);
  min-height: 78px;
  padding: 13px 14px 12px 52px;
  position: relative;
}

.jobs-stat-card::before {
  background: linear-gradient(180deg, var(--jobs-primary), transparent);
  border-radius: 8px 0 0 8px;
  content: "";
  inset: 0 auto 0 0;
  opacity: 0.9;
  position: absolute;
  width: 4px;
}

.jobs-stat-icon {
  align-items: center;
  background: var(--jobs-primary-soft);
  border-radius: 8px;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  left: 14px;
  margin-bottom: 0;
  position: absolute;
  top: 14px;
  width: 32px;
}

.jobs-stat-icon .v-icon {
  color: var(--jobs-primary-dark);
  font-size: 19px;
}

.jobs-stat-card span {
  color: var(--jobs-muted);
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.jobs-stat-card strong {
  color: var(--jobs-ink);
  display: block;
  font-size: 24px;
  line-height: 1;
  margin-top: 5px;
}

.jobs-stat-card small {
  color: #9e9a91;
  display: block;
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}

.jobs-stat-card--cancelled::before,
.jobs-stat-card--cancelled .jobs-stat-icon {
  background: #be3b32;
}

.jobs-stat-card--cancelled .jobs-stat-icon .v-icon,
.jobs-stat-card--completed .jobs-stat-icon .v-icon,
.jobs-stat-card--total .jobs-stat-icon .v-icon {
  color: #ffffff;
}

.jobs-stat-card--completed::before,
.jobs-stat-card--completed .jobs-stat-icon {
  background: #12764c;
}

.jobs-stat-card--total::before,
.jobs-stat-card--total .jobs-stat-icon {
  background: #2456b8;
}

.jobs-filter-panel {
  background: linear-gradient(180deg, #ffffff 0%, #fbfaf7 100%);
  border: 1px solid var(--jobs-border);
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
  margin: 0 var(--oms-list-section-x, 30px);
  padding: 12px 14px 2px;
}

.jobs-section-title {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.jobs-section-title h2 {
  font-size: 16px;
  line-height: 1.3;
  margin-top: 1px;
}

.jobs-reset-link {
  align-items: center;
  background: transparent;
  border: 0.09375rem solid var(--jobs-primary, #ea7a1c);
  border-radius: 8px;
  color: var(--jobs-primary, #ea7a1c);
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 6px;
  padding: 7px 10px;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.jobs-reset-link:hover,
.jobs-reset-link:focus {
  background: rgba(245, 130, 32, 0.1);
  border-color: var(--jobs-primary, #ea7a1c);
  color: var(--jobs-primary-dark, #c55a00);
}

.jobs-filter-grid {
  align-items: start;
  display: grid !important;
  gap: 8px;
  grid-template-columns: repeat(auto-fit, minmax(158px, 1fr));
  margin: 0 !important;
}

.jobs-filter-field {
  flex-basis: auto !important;
  max-width: none !important;
  min-width: 0;
  padding: 0 !important;
}

.jobs-revamp .jobs-filter-panel .v-input__slot {
  border-color: #dbe2ec !important;
  border-radius: 8px !important;
  margin-bottom: 4px !important;
  min-height: 40px !important;
}

.jobs-revamp .jobs-filter-panel .v-input {
  margin-top: 0;
  padding-top: 0;
}

.jobs-revamp .jobs-filter-panel .v-text-field__details {
  display: none;
}

.jobs-revamp .jobs-filter-panel .v-label,
.jobs-revamp .jobs-filter-panel .v-select__selection,
.jobs-revamp .jobs-filter-panel input {
  color: #334155 !important;
  font-size: 12px;
  font-weight: 700;
}

.jobs-revamp .jobs-filter-panel .v-icon {
  color: #64748b;
  font-size: 18px;
}

.jobs-revamp .jobs-filter-panel .e-input-group {
  border: 1px solid #dbe2ec !important;
  border-radius: 8px;
  min-height: 40px;
  padding: 5px 9px;
}

.jobs-revamp .jobs-filter-panel .e-input-group input {
  min-height: 28px;
}

.jobs-table-card {
  background: #ffffff;
  padding: 0 var(--oms-list-section-x, 30px) 28px !important;
  overflow-x: auto;
}

.jobs-revamp #jobsTable {
  background: transparent;
}

.jobs-revamp #jobsTable .v-table__overflow {
  background: #ffffff;
  border: 1px solid var(--jobs-border);
  border-radius: 0 0 8px 8px;
  overflow-x: auto;
}

.jobs-revamp #jobsTable table.v-table {
  border-collapse: separate;
  border-spacing: 0 0.375rem;
  min-width: var(--oms-list-table-min-width, 96rem);
}

.jobs-revamp #jobsTable table.v-table thead tr {
  background: transparent;
}

.jobs-revamp #jobsTable table.v-table tbody tr {
  background: var(--jobs-row);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.045);
}

.jobs-revamp #jobsTable table.v-table tbody td {
  background: var(--jobs-row);
  border-bottom: 1px solid #e7ecf3;
  border-top: 1px solid #e7ecf3;
  color: #2e3748;
  font-size: 0.8125rem !important;
  height: auto;
  overflow-wrap: break-word;
  padding: 0.75rem;
  vertical-align: middle;
}

.jobs-revamp #jobsTable table.v-table tbody td:first-child {
  border-left: 4px solid var(--jobs-primary);
  border-radius: 8px 0 0 8px;
  color: var(--jobs-primary-dark);
  font-weight: 700;
  padding-left: 0.625rem;
}

.jobs-revamp #jobsTable table.v-table tbody td:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid #eef1f5;
}

.jobs-revamp #jobsTable table.v-table th:nth-child(4),
.jobs-revamp #jobsTable table.v-table td:nth-child(4) {
  text-align: center;
}

.jobs-revamp #jobsTable table.v-table tbody tr:hover td {
  background: #fbfdff;
}

.jobs-revamp #jobsTable table.v-table tbody tr:hover td:first-child {
  border-left-color: #2563eb;
}

.jobs-revamp .track-ass-btn {
  align-items: center;
  background: var(--jobs-primary) !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 5px 12px rgba(245, 130, 32, 0.24);
  color: #ffffff;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  gap: 6px;
  justify-content: center;
  padding: 7px 10px !important;
  transition: transform 0.16s ease, box-shadow 0.16s ease;
  white-space: nowrap;
}

.jobs-revamp .track-ass-btn:hover {
  box-shadow: 0 9px 18px rgba(245, 130, 32, 0.3);
  transform: translateY(-1px);
}

.jobs-table-toolbar {
  display: none;
  align-items: center;
  background:
    linear-gradient(90deg, rgba(15, 23, 42, 0.04), rgba(245, 130, 32, 0.06)),
    #ffffff;
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  padding: 16px 18px;
}

.jobs-table-toolbar span {
  color: var(--jobs-primary-dark);
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}

.jobs-table-toolbar h3 {
  color: var(--jobs-ink);
  font-size: 20px;
  line-height: 1.2;
  margin: 3px 0 0;
}

.jobs-table-meta {
  display: none;
  align-items: center;
  display: flex;
  gap: 8px;
}

.jobs-table-meta span {
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 999px;
  color: var(--jobs-muted);
  padding: 7px 11px;
  text-transform: none;
}

.jobs-id-cell,
.jobs-customer-cell,
.jobs-date-cell,
.jobs-route-cell,
.jobs-progress-cell,
.jobs-comment-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.jobs-id-cell span,
.jobs-route-cell span,
.jobs-progress-head span,
.jobs-comment-time,
.jobs-customer-cell span {
  color: var(--jobs-muted);
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
}

.jobs-id-row {
  align-items: center;
  display: inline-flex;
  gap: 7px;
  white-space: nowrap;
}

.jobs-id-row > div {
  align-items: center;
  display: inline-flex;
  padding-left: 0 !important;
}

.jobs-id-row .v-icon {
  align-items: center;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 7px;
  color: var(--jobs-primary-dark) !important;
  display: inline-flex;
  font-size: 17px !important;
  height: 26px;
  justify-content: center;
  width: 26px;
}

.jobs-id-cell strong {
  color: #0f172a;
  font-size: 15px;
  letter-spacing: 0;
}

.jobs-id-cell button,
.jobs-id-cell .v-btn {
  margin: 0 !important;
}

.jobs-country-pill {
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  color: #334155;
  display: inline-flex;
  font-size: 12px;
  font-weight: 800;
  gap: 7px;
  padding: 7px 10px;
  white-space: nowrap;
}

.jobs-country-pill img {
  border-radius: 999px;
  height: 18px;
  object-fit: cover;
  width: 18px;
}

.jobs-customer-cell strong {
  color: #111827;
  font-size: 13px;
  line-height: 1.25;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jobs-assignment-total {
  align-items: center;
  background: #eef6ff;
  border: 1px solid #d8ebff;
  border-radius: 8px;
  color: #0f5a9d;
  display: inline-flex;
  font-size: 15px;
  font-weight: 800;
  height: 34px;
  justify-content: center;
  min-width: 42px;
}

.jobs-date-cell {
  align-items: center;
  color: #334155;
  flex-direction: row;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.jobs-date-cell .v-icon {
  color: #64748b;
}

.jobs-route-combined-cell {
  min-width: 13.75rem;
}

.jobs-route-pair {
  display: flex;
  flex-direction: column;
  gap: 0.4375rem;
  max-width: 100%;
  min-width: 0;
  position: relative;
}

.jobs-route-pair::before {
  border-left: 1px dashed #cbd5e1;
  bottom: 1.125rem;
  content: "";
  left: 0.25rem;
  position: absolute;
  top: 1.125rem;
}

.jobs-route-point {
  display: flex;
  flex-direction: column;
  gap: 0.1875rem;
  min-width: 0;
  padding-left: 1.125rem;
  position: relative;
}

.jobs-route-point::before {
  background: var(--jobs-primary);
  border: 2px solid #fff7ed;
  border-radius: 999px;
  box-shadow: 0 0 0 1px rgba(245, 130, 32, 0.24);
  content: "";
  height: 0.5625rem;
  left: 0;
  position: absolute;
  top: 0.25rem;
  width: 0.5625rem;
  z-index: 1;
}

.jobs-route-point--destination::before {
  background: #2563eb;
  border-color: #eff6ff;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.22);
}

.jobs-route-point span {
  color: var(--jobs-muted);
  font-size: 0.6875rem;
  font-weight: 800;
  line-height: 1.2;
  text-transform: uppercase;
}

.jobs-route-point strong {
  color: #1f2937;
  display: block;
  font-size: 0.8125rem;
  line-height: 1.3;
  max-width: 100%;
  overflow-wrap: anywhere;
}

.jobs-route-cell {
  background: transparent;
  border: 0;
  border-radius: 0;
  min-width: 145px;
  padding: 0 0 0 13px;
  position: relative;
  text-align: left;
}

.jobs-route-cell::before {
  background: var(--jobs-primary);
  border-radius: 999px;
  content: "";
  height: 8px;
  left: 0;
  position: absolute;
  top: 4px;
  width: 8px;
}

.jobs-route-cell--destination::before {
  background: #2563eb;
}

.jobs-route-cell strong {
  color: #1f2937;
  font-size: 13px;
  line-height: 1.35;
}

.jobs-progress-cell {
  min-width: 132px;
}

.jobs-progress-head {
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.jobs-progress-head strong {
  color: #111827;
  font-size: 13px;
}

.jobs-progress-track {
  background: #eef2f7;
  border-radius: 999px;
  height: 7px;
  overflow: hidden;
  width: 100%;
}

.jobs-progress-track span {
  background: linear-gradient(90deg, var(--jobs-primary), #fbbf24);
  border-radius: inherit;
  display: block;
  height: 100%;
  min-width: 8px;
}

.jobs-progress-cell--empty {
  color: var(--jobs-muted);
  font-size: 12px;
  font-weight: 700;
}

.jobs-status-pill {
  border-radius: 999px;
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0;
  line-height: 1.2;
  min-width: 112px;
  padding: 8px 10px;
  text-align: center;
}

.jobs-status-pill--open {
  background: #fff7ed;
  color: #c2410c;
}

.jobs-status-pill--moving {
  background: #eff6ff;
  color: #1d4ed8;
}

.jobs-status-pill--pending {
  background: #fef3c7;
  color: #92400e;
}

.jobs-status-pill--done {
  background: #ecfdf5;
  color: #047857;
}

.jobs-status-pill--cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

.jobs-status-pill--neutral {
  background: #f1f5f9;
  color: #475569;
}

.jobs-comment-cell {
  max-width: 180px;
}

.jobs-comment-preview {
  color: #1f2937;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
}

.jobs-comment-cell--empty .jobs-comment-time {
  color: #94a3b8;
}

.jobs-revamp .jobs-comment-action {
  display: inline-flex;
  margin-top: 8px;
}

.jobs-revamp .jobs-comment-action .comment_btn.blue-button {
  align-items: center !important;
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  color: #667085 !important;
  display: inline-flex !important;
  height: 32px !important;
  justify-content: center !important;
  margin: 0 !important;
  min-width: 32px !important;
  padding: 0 !important;
  width: 32px !important;
}

.jobs-revamp .jobs-comment-action .comment_btn.blue-button:hover {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  color: var(--jobs-primary-dark) !important;
}

.jobs-revamp .jobs-comment-action .comment_btn.blue-button .v-btn__content {
  align-items: center;
  display: inline-flex;
  font-size: 0;
  justify-content: center;
  line-height: 1;
}

.jobs-revamp .jobs-comment-action .comment_btn.blue-button .v-btn__content::before {
  content: "+";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr {
  transition: box-shadow 0.16s ease, transform 0.16s ease;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr:hover {
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  transform: translateY(-1px);
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr.colorchange {
  box-shadow: inset 4px 0 0 #ef4444, 0 6px 18px rgba(23, 32, 51, 0.06);
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr.colorchange td:first-child {
  border-left-color: #ef4444;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr.colorchangeyellow {
  box-shadow: inset 4px 0 0 #f59e0b, 0 6px 18px rgba(23, 32, 51, 0.06);
}

.jobs-revamp--modern
  #jobsTable
  table.v-table
  tbody
  tr.colorchangeyellow
  td:first-child {
  border-left-color: #f59e0b;
}

.jobs-revamp {
  --jobs-bg: #f5f6fa;
  --jobs-panel: #ffffff;
  --jobs-ink: #1f2430;
  --jobs-muted: #7a8494;
  --jobs-primary: #ff7a1a;
  --jobs-primary-dark: #e6670f;
  --jobs-primary-soft: #fff3e8;
  --jobs-border: #e6e9ef;
  --jobs-row: #ffffff;
  --jobs-shadow: none;
  background: var(--jobs-bg);
  padding: 0;
}

.jobs-panel {
  background: var(--jobs-bg) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.jobs-board-head {
  align-items: flex-start;
  background: var(--jobs-bg);
  border-bottom: 1px solid #edf0f5;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  padding: 28px 30px 16px;
}

.jobs-title-area h1 {
  color: var(--jobs-ink);
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.15;
  margin: 0;
}

.jobs-title-area p {
  color: #858e9f;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  margin: 8px 0 0;
}

.jobs-view-tabs {
  align-items: center;
  display: flex;
  gap: 28px;
  margin-top: 18px;
}

.jobs-view-tab,
.jobs-period-tab {
  border: 0;
  cursor: pointer;
  font-family: inherit;
  letter-spacing: 0;
  outline: none;
}

.jobs-view-tab {
  background: transparent;
  border-bottom: 2px solid transparent;
  color: #8c95a5;
  font-size: 14px;
  font-weight: 800;
  padding: 0 2px 12px;
}

.jobs-view-tab--active {
  border-bottom-color: var(--jobs-primary);
  color: var(--jobs-ink);
}

.jobs-period-tabs {
  align-items: center;
  background: #eceef4;
  border-radius: 10px;
  display: flex;
  gap: 6px;
  min-width: 330px;
  padding: 5px;
}

.jobs-period-tab {
  background: transparent;
  border-radius: 8px;
  color: #858e9f;
  flex: 1;
  font-size: 13px;
  font-weight: 800;
  min-height: 36px;
  padding: 8px 18px;
  text-align: center;
  white-space: nowrap;
}

.jobs-period-tab--active {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(31, 36, 48, 0.12);
  color: var(--jobs-ink);
}

.jobs-stats-grid {
  gap: 14px;
  padding: 24px 30px 18px;
}

.jobs-stat-card {
  background: #ffffff;
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(31, 36, 48, 0.04);
  min-height: 116px;
  padding: 24px 56px 18px 20px;
}

.jobs-stat-card::before {
  display: none;
}

.jobs-stat-card span {
  color: #80899a;
  font-size: 13px;
  font-weight: 800;
  text-transform: none;
}

.jobs-stat-card strong {
  color: var(--jobs-ink);
  font-size: 32px;
  font-weight: 900;
  line-height: 1;
  margin-top: 22px;
}

.jobs-stat-card small {
  color: #9aa3b2;
  font-size: 12px;
  font-weight: 600;
  margin-top: 10px;
}

.jobs-stat-icon {
  border-radius: 8px;
  height: 32px;
  left: auto;
  right: 18px;
  top: 18px;
  width: 32px;
}

.jobs-stat-card--active .jobs-stat-icon {
  background: #fff3e8;
}

.jobs-stat-card--transit .jobs-stat-icon {
  background: #fff4e7;
}

.jobs-stat-card--awaiting .jobs-stat-icon {
  background: #fff0ef;
}

.jobs-stat-card--trucks .jobs-stat-icon {
  background: #eef2ff;
}

.jobs-stat-card--active .jobs-stat-icon .v-icon,
.jobs-stat-card--transit .jobs-stat-icon .v-icon {
  color: var(--jobs-primary);
}

.jobs-stat-card--awaiting .jobs-stat-icon .v-icon {
  color: #ef5b4f;
}

.jobs-stat-card--trucks .jobs-stat-icon .v-icon {
  color: #4c63e6;
}

.jobs-filter-panel {
  background: #ffffff;
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  margin: 0 var(--oms-list-section-x, 30px) 16px;
  padding: 10px;
}

.jobs-filter-grid {
  align-items: center;
  gap: 10px;
  grid-template-columns: minmax(160px, 0.8fr) minmax(260px, 1.4fr) repeat(3, minmax(170px, 1fr)) minmax(96px, auto);
}

.jobs-filter-field,
.jobs-filter-actions {
  flex-basis: auto !important;
  max-width: none !important;
  min-width: 0;
  padding: 0 !important;
}

.jobs-filter-actions {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

.jobs-revamp .jobs-filter-panel .v-input__slot,
.jobs-revamp .jobs-filter-panel .e-input-group {
  background: #fbfcfe !important;
  border: 1px solid #dfe4ec !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  margin-bottom: 0 !important;
  min-height: 42px !important;
}

.jobs-revamp .jobs-filter-panel .v-text-field--outline > .v-input__control > .v-input__slot {
  border-width: 1px !important;
}

.jobs-revamp .jobs-filter-panel .e-input-group {
  padding: 6px 10px;
}

.jobs-revamp .jobs-filter-panel .v-label,
.jobs-revamp .jobs-filter-panel .v-select__selection,
.jobs-revamp .jobs-filter-panel input {
  color: #5f6878 !important;
  font-size: 13px;
  font-weight: 700;
}

.jobs-reset-link {
  align-items: center;
  background: transparent;
  border: 0.09375rem solid var(--jobs-primary, #ea7a1c);
  border-radius: 8px;
  color: var(--jobs-primary, #ea7a1c);
  display: inline-flex;
  font-size: 13px;
  font-weight: 800;
  gap: 7px;
  justify-content: center;
  min-height: 42px;
  padding: 9px 14px;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.jobs-reset-link:hover,
.jobs-reset-link:focus {
  background: rgba(245, 130, 32, 0.1);
  border-color: var(--jobs-primary, #ea7a1c);
  color: var(--jobs-primary-dark, #c55a00);
  outline: none;
}

.jobs-table-card {
  background: var(--jobs-bg);
  padding: 0 var(--oms-list-section-x, 30px) 28px !important;
}

.jobs-revamp #jobsTable .v-table__overflow {
  background: #ffffff;
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  overflow-x: auto;
}

.jobs-revamp #jobsTable table.v-table {
  border-collapse: collapse;
  border-spacing: 0;
  min-width: 1280px;
}

.jobs-revamp #jobsTable table.v-table thead th:first-child,
.jobs-revamp #jobsTable table.v-table thead th:last-child {
  border-radius: 0;
}

.jobs-revamp #jobsTable table.v-table tbody tr {
  background: #ffffff;
  box-shadow: none;
}

.jobs-revamp #jobsTable table.v-table tbody td {
  background: #ffffff;
  border-bottom: 1px solid #eef1f5 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 0 !important;
  color: #2f3744;
  font-size: 13px !important;
  height: 74px;
  padding: 15px 16px !important;
  text-align: left !important;
  vertical-align: middle;
}

.jobs-revamp #jobsTable table.v-table tbody td:first-child {
  border-left: 0 !important;
  border-radius: 0;
  color: var(--jobs-ink);
  padding-left: 16px !important;
}

.jobs-revamp #jobsTable table.v-table tbody td:last-child {
  border-radius: 0;
  border-right: 0 !important;
}

.jobs-revamp #jobsTable table.v-table tbody tr:hover td {
  background: #fbfcff;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr:hover {
  box-shadow: none;
  transform: none;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr.colorchange,
.jobs-revamp--modern #jobsTable table.v-table tbody tr.colorchangeyellow {
  box-shadow: inset 3px 0 0 #f59e0b;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr.colorchange {
  box-shadow: inset 3px 0 0 #ef4444;
}

.jobs-id-row .v-icon {
  background: #ffffff;
  border: 1px solid #e6e9ef;
  color: #9aa3b2 !important;
}

.jobs-country-pill,
.jobs-assignment-total {
  background: #f5f6f9;
  border-color: #e8ebf1;
  border-radius: 8px;
  color: #4c5564;
}

.jobs-date-cell {
  align-items: flex-start;
  flex-direction: column;
  gap: 2px;
}

.jobs-route-cell {
  min-width: 132px;
  padding-left: 0;
}

.jobs-route-cell::before {
  display: none;
}

.jobs-progress-track {
  height: 5px;
}

.jobs-progress-track span {
  background: var(--jobs-primary);
}

.jobs-status-pill {
  border-radius: 999px;
  font-size: 12px;
  min-width: 112px;
  padding: 7px 12px;
}

.jobs-status-pill::before {
  border-radius: 999px;
  content: "";
  height: 6px;
  margin-right: 7px;
  width: 6px;
}

.jobs-status-pill--open::before {
  background: #f59e0b;
}

.jobs-status-pill--moving::before {
  background: #6477f2;
}

.jobs-status-pill--pending::before {
  background: #f2aa24;
}

.jobs-status-pill--done::before {
  background: #19a66a;
}

.jobs-status-pill--cancelled::before {
  background: #dc2626;
}

.jobs-status-pill--neutral::before {
  background: #94a3b8;
}

.jobs-revamp .track-ass-btn {
  background: #ffffff !important;
  border: 1px solid #dfe5ee !important;
  border-radius: 8px !important;
  box-shadow: none !important;
  color: #2f3744 !important;
  min-height: 34px;
  padding: 7px 13px !important;
}

.jobs-revamp .track-ass-btn .v-icon {
  color: #9aa3b2 !important;
}

@media (max-width: 1120px) {
  .jobs-board-head {
    align-items: stretch;
    flex-direction: column;
  }

  .jobs-period-tabs {
    max-width: 420px;
    min-width: 0;
  }
}

@media (max-width: 1260px) {
  .jobs-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .jobs-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .jobs-board-head,
  .jobs-stats-grid,
  .jobs-filter-grid {
    grid-template-columns: 1fr;
  }

  .jobs-period-tabs,
  .jobs-view-tabs {
    overflow-x: auto;
  }

  .jobs-board-head,
  .jobs-stats-grid,
  .jobs-filter-panel,
  .jobs-table-card {
    margin-left: 16px;
    margin-right: 16px;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .jobs-board-head {
    margin: 0;
    padding: 22px 16px 14px !important;
  }
}

.jobs-revamp--modern {
  --jobs-bg: #f6f5f2;
  --jobs-panel: #ffffff;
  --jobs-ink: #3a382f;
  --jobs-navy: #1a1916;
  --jobs-muted: #74716a;
  --jobs-primary: #ea7a1c;
  --jobs-primary-dark: #d96a10;
  --jobs-primary-soft: #fdf0e4;
  --jobs-border: #e4e1d9;
  --jobs-row: #ffffff;
  --jobs-shadow: 0 18px 45px rgba(26, 25, 22, 0.08);
  background: var(--jobs-bg);
  padding: 4px;
}

.jobs-revamp--modern .jobs-panel {
  background: #ffffff !important;
  border: 0 !important;
  border-radius: 8px !important;
  box-shadow: var(--jobs-shadow) !important;
  overflow: hidden;
}

.jobs-revamp--modern .jobs-stats-grid {
  gap: var(--oms-list-stat-gap, 10px);
  grid-template-columns: var(--oms-list-stat-columns, repeat(4, minmax(0, 1fr)));
  padding: var(--oms-list-section-y, 14px) var(--oms-list-section-x, 30px);
}

.jobs-revamp--modern .jobs-stat-card {
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.94), #ffffff),
    var(--jobs-row);
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(26, 25, 22, 0.04);
  min-height: 78px;
  padding: 13px 14px 12px 52px;
  position: relative;
}

.jobs-revamp--modern .jobs-stat-card::before {
  background: linear-gradient(180deg, var(--jobs-primary), transparent);
  border-radius: 8px 0 0 8px;
  content: "";
  display: block;
  inset: 0 auto 0 0;
  opacity: 0.9;
  position: absolute;
  width: 4px;
}

.jobs-revamp--modern .jobs-stat-icon {
  background: var(--jobs-primary-soft);
  border-radius: 8px;
  height: 32px;
  left: 14px;
  right: auto;
  top: 14px;
  width: 32px;
}

.jobs-revamp--modern .jobs-stat-card span {
  color: var(--jobs-muted);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}

.jobs-revamp--modern .jobs-stat-card strong {
  color: var(--jobs-ink);
  font-size: 24px;
  font-weight: 700;
  margin-top: 5px;
}

.jobs-revamp--modern .jobs-stat-card small {
  color: #9e9a91;
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}

.jobs-revamp--modern .jobs-stat-card--cancelled::before,
.jobs-revamp--modern .jobs-stat-card--cancelled .jobs-stat-icon {
  background: #be3b32;
}

.jobs-revamp--modern .jobs-stat-card--completed::before,
.jobs-revamp--modern .jobs-stat-card--completed .jobs-stat-icon {
  background: #12764c;
}

.jobs-revamp--modern .jobs-stat-card--total::before,
.jobs-revamp--modern .jobs-stat-card--total .jobs-stat-icon {
  background: #2456b8;
}

.jobs-revamp--modern .jobs-filter-panel {
  background: linear-gradient(180deg, #ffffff 0%, #fbfaf7 100%);
  border: 1px solid var(--jobs-border);
  border-bottom: 0;
  border-radius: 8px 8px 0 0;
  margin: 0 var(--oms-list-section-x, 30px);
  padding: 12px 14px 12px;
}

.jobs-revamp--modern .jobs-filter-grid--modern {
  align-items: end;
  display: grid !important;
  gap: 10px;
  margin: 0 !important;
}

.jobs-revamp--modern .jobs-filter-grid--modern {
  grid-template-columns:
    minmax(140px, 0.85fr)
    minmax(220px, 1.3fr)
    minmax(150px, 0.9fr)
    minmax(190px, 1fr)
    minmax(160px, 1fr)
    minmax(180px, 1fr)
    minmax(92px, auto);
}

.jobs-revamp--modern .jobs-filter-actions {
  align-items: stretch;
  align-self: stretch;
  display: flex;
  grid-column: -2 / -1;
  justify-content: flex-end;
}

.jobs-revamp--modern .jobs-reset-link {
  min-height: 42px;
  width: 100%;
}

.jobs-revamp--modern .jobs-reset-link {
  background: transparent;
  border: 0.09375rem solid var(--jobs-primary, #ea7a1c);
  color: var(--jobs-primary, #ea7a1c);
}

.jobs-revamp--modern .jobs-reset-link:hover,
.jobs-revamp--modern .jobs-reset-link:focus {
  background: rgba(245, 130, 32, 0.1);
  border-color: var(--jobs-primary, #ea7a1c);
  color: var(--jobs-primary-dark, #c55a00);
}

.jobs-revamp--modern .jobs-table-card {
  background: #ffffff;
  padding: 0 var(--oms-list-section-x, 30px) 28px !important;
}

.jobs-revamp--modern #jobsTable .v-table__overflow {
  background: #ffffff;
  border: 1px solid var(--jobs-border);
  border-radius: 0 0 8px 8px;
  overflow-x: auto;
}

.jobs-revamp--modern #jobsTable table.v-table {
  border-collapse: separate;
  border-spacing: 0 6px;
  min-width: var(--oms-list-table-min-width, 96rem);
}

.jobs-revamp--modern #jobsTable table.v-table thead th:first-child {
  border-radius: 8px 0 0 8px;
}

.jobs-revamp--modern #jobsTable table.v-table thead th:last-child {
  border-radius: 0 8px 8px 0;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr {
  background: var(--jobs-row);
  box-shadow: 0 4px 14px rgba(26, 25, 22, 0.045);
}

.jobs-revamp--modern #jobsTable table.v-table tbody td {
  background: var(--jobs-row);
  border-bottom: 1px solid #f0eee8 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-top: 1px solid #f0eee8 !important;
  color: #3a382f;
  font-size: 13px !important;
  height: auto;
  padding: 12px !important;
  vertical-align: middle;
}

.jobs-revamp--modern #jobsTable table.v-table tbody td:first-child {
  border-left: 4px solid var(--jobs-primary) !important;
  border-radius: 8px 0 0 8px;
  color: var(--jobs-primary-dark);
  font-weight: 700;
  padding-left: 10px !important;
}

.jobs-revamp--modern #jobsTable table.v-table tbody td:last-child {
  border-radius: 0 8px 8px 0;
  border-right: 1px solid #f0eee8 !important;
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr:hover {
  box-shadow: 0 12px 28px rgba(26, 25, 22, 0.12);
  transform: translateY(-1px);
}

.jobs-revamp--modern #jobsTable table.v-table tbody tr:hover td {
  background: #fffaf4;
}

.jobs-revamp--modern .jobs-date-cell {
  align-items: center;
  flex-direction: row;
  font-size: 0.6875rem;
  gap: 0.1875rem;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  min-width: 0;
  white-space: nowrap;
  width: 100%;
}

.jobs-revamp--modern .jobs-date-cell .v-icon,
.jobs-revamp--modern .jobs-date-cell span {
  flex: 0 0 auto;
}

.jobs-revamp--modern .jobs-date-cell .v-icon {
  font-size: 0.875rem !important;
}

.jobs-revamp--modern .jobs-date-cell span {
  font-size: 0.6875rem;
  line-height: 1.2;
}

.jobs-revamp--modern .jobs-route-cell {
  min-width: 145px;
  padding: 0 0 0 13px;
}

.jobs-revamp--modern .jobs-route-cell::before {
  display: block;
}

.jobs-revamp--modern .jobs-progress-track {
  height: 7px;
}

.jobs-revamp--modern .jobs-progress-track span {
  background: linear-gradient(90deg, var(--jobs-primary), #fbbf24);
}

.jobs-revamp--modern .jobs-status-pill {
  font-size: 11px;
  padding: 8px 10px;
}

.jobs-revamp--modern .jobs-status-pill::before {
  display: none;
}

.jobs-revamp--modern .track-ass-btn {
  background: var(--jobs-primary) !important;
  border: 0 !important;
  box-shadow: 0 5px 12px rgba(234, 122, 28, 0.24) !important;
  color: #ffffff !important;
}

.jobs-revamp--modern .track-ass-btn .v-icon {
  color: #ffffff !important;
}

@media (max-width: 1260px) {
  .jobs-revamp--modern .jobs-filter-grid--modern {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .jobs-revamp--modern .jobs-filter-actions {
    grid-column: auto;
  }
}

@media (max-width: 760px) {
  .jobs-revamp--modern .jobs-filter-grid--modern {
    grid-template-columns: 1fr;
  }
}

.jobs-revamp .jobs-filter-panel {
  overflow: visible;
}

.jobs-revamp .jobs-filter-grid--modern {
  align-items: stretch !important;
}

.jobs-revamp .jobs-filter-field,
.jobs-revamp .jobs-filter-actions {
  align-items: stretch;
  display: flex !important;
  max-width: none !important;
  min-height: 42px;
  width: 100%;
}

.jobs-revamp .jobs-filter-date {
  margin: 0 !important;
  max-width: none !important;
  padding-top: 0 !important;
}

.jobs-revamp .jobs-filter-panel .gap {
  bottom: auto !important;
  position: static !important;
  right: auto !important;
}

.jobs-revamp .jobs-filter-panel .v-input {
  align-items: stretch;
  display: flex;
  height: 42px;
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
}

.jobs-revamp .jobs-filter-panel .v-input__control,
.jobs-revamp .jobs-filter-panel .v-input__slot,
.jobs-revamp .jobs-filter-panel .v-select__slot,
.jobs-revamp .jobs-filter-panel .v-text-field__slot {
  min-height: 42px !important;
  width: 100%;
}

.jobs-revamp .jobs-filter-panel .v-input__slot {
  align-items: center !important;
  box-sizing: border-box;
  height: 42px !important;
  margin: 0 !important;
  padding: 0 12px !important;
}

.jobs-revamp .jobs-filter-panel .v-text-field--outline > .v-input__control > .v-input__slot {
  border-width: 1px !important;
}

.jobs-revamp .jobs-filter-panel .v-text-field input,
.jobs-revamp .jobs-filter-panel .v-select input {
  line-height: 40px !important;
  margin: 0 !important;
  max-height: 40px !important;
  padding: 0 !important;
}

.jobs-revamp .jobs-filter-panel .v-select__selections {
  align-items: center;
  min-height: 40px !important;
  overflow: hidden;
  padding: 0 !important;
}

.jobs-revamp .jobs-filter-panel .v-select.v-select--chips .v-select__selections {
  max-height: 40px !important;
  overflow: hidden !important;
}

.jobs-revamp .jobs-filter-panel .v-input__append-inner,
.jobs-revamp .jobs-filter-panel .v-input__append-outer {
  align-self: center;
  margin-top: 0 !important;
}

.jobs-revamp .jobs-filter-panel .v-text-field__details {
  display: none !important;
}

.jobs-revamp .jobs-filter-panel #jobDate {
  padding-top: 0 !important;
}

.jobs-revamp .jobs-filter-panel .e-input-group {
  align-items: center;
  box-sizing: border-box;
  display: flex !important;
  height: 42px !important;
  margin: 0 !important;
  min-height: 42px !important;
  padding: 0 12px !important;
  width: 100%;
}

.jobs-revamp .jobs-filter-panel .e-input-group input {
  height: 100% !important;
  line-height: normal !important;
  min-height: 0 !important;
  padding: 0 !important;
}

.jobs-revamp .jobs-filter-actions {
  align-self: stretch;
}

.jobs-revamp .jobs-filter-actions .jobs-reset-link {
  height: 42px;
  min-height: 42px;
  width: 100%;
}

/* Jobs-list layout guard for Vuetify-generated table markup. */
.jobs-revamp--modern .jobs-nav-grid,
.jobs-revamp--modern .jobs-stats-grid,
.jobs-revamp--modern .jobs-filter-panel,
.jobs-revamp--modern .jobs-table-card {
  max-width: 100%;
  min-width: 0;
}

.jobs-revamp--modern .jobs-nav-grid {
  grid-template-columns: var(
    --oms-list-nav-columns,
    minmax(0, max-content) minmax(0, 1fr)
  );
}

.jobs-revamp--modern .jobs-status-tabs {
  justify-self: end;
}

#nav .jobs-revamp--modern .jobs-table-card.oms-list-table-card {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

.jobs-revamp--modern .jobs-table-card {
  overflow-x: auto;
  overflow-y: visible;
}

#nav .jobs-revamp--modern #jobsTable .v-table__overflow {
  overflow-x: auto !important;
  overflow-y: visible !important;
  -webkit-overflow-scrolling: touch;
}

.jobs-revamp--modern #jobsTable .v-table__overflow {
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

#nav .jobs-revamp--modern #jobsTable table.v-table {
  table-layout: auto !important;
}

.jobs-revamp--modern #jobsTable table.v-table {
  min-width: var(--oms-list-table-min-width, 96rem) !important;
  width: 100%;
}

.jobs-revamp--modern #jobsTable table.v-table thead th,
.jobs-revamp--modern #jobsTable table.v-table tbody td {
  box-sizing: border-box;
  line-height: 1.35;
  overflow-wrap: normal !important;
  vertical-align: middle;
  word-break: normal !important;
}

.jobs-revamp--modern #jobsTable table.v-table tbody td {
  height: 4.25rem;
  padding: 0.625rem 0.75rem !important;
}

.jobs-revamp--modern #jobsTable table.v-table tbody td + td,
.jobs-revamp--modern #jobsTable table.v-table thead th + th {
  background-clip: padding-box;
  border-left: 0.375rem solid transparent !important;
}

.jobs-revamp--modern #jobsTable table.v-table thead th {
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}

.jobs-revamp--modern #jobsTable table.v-table th:nth-child(4),
.jobs-revamp--modern #jobsTable table.v-table td:nth-child(4) {
  text-align: center !important;
}

.jobs-revamp--modern .jobs-customer-cell,
.jobs-revamp--modern .jobs-route-point,
.jobs-revamp--modern .oms-comment-cell {
  min-width: 0;
  width: 100%;
}

.jobs-revamp--modern .jobs-customer-cell strong,
.jobs-revamp--modern .jobs-customer-cell span,
.jobs-revamp--modern .jobs-route-point strong,
.jobs-revamp--modern .oms-comment-cell__text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jobs-revamp--modern .jobs-route-point strong {
  overflow-wrap: normal;
}

.jobs-revamp--modern .jobs-route-pair {
  gap: 0.25rem;
}

.jobs-revamp--modern .jobs-progress-cell {
  align-items: stretch;
  gap: 0.25rem;
  min-width: 0;
}

.jobs-revamp--modern .jobs-progress-head {
  align-items: baseline;
  flex-wrap: nowrap;
}

.jobs-revamp--modern .jobs-progress-head strong,
.jobs-revamp--modern .jobs-progress-head span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jobs-revamp--modern .jobs-progress-cell .v-btn,
.jobs-revamp--modern .jobs-progress-cell button {
  align-self: flex-start;
  margin-top: 0.125rem !important;
}

.jobs-revamp--modern .jobs-progress-cell .log {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.125rem;
}

.jobs-revamp--modern .jobs-progress-cell .view-ass-btn {
  align-self: flex-start;
  min-height: 1.75rem !important;
  padding: 0 0.625rem !important;
}

.jobs-revamp--modern .jobs-status-pill,
.jobs-revamp--modern .track-ass-btn,
.jobs-revamp--modern .jobs-assignment-total,
.jobs-revamp--modern .jobs-country-pill {
  white-space: nowrap;
}

.jobs-revamp--modern .jobs-country-pill {
  max-width: 100%;
  overflow: hidden;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-overflow: ellipsis;
}

.jobs-revamp--modern .jobs-status-pill {
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.jobs-revamp--modern .jobs-comments-column {
  text-align: center !important;
}

.jobs-revamp--modern .jobs-comments-column .oms-comment-cell {
  align-items: center;
  justify-content: center;
}

.jobs-revamp--modern .jobs-comments-column .oms-comment-cell__text {
  display: none;
}

.jobs-revamp--modern .jobs-comment-action {
  margin-top: 0;
}

@media (max-width: 80rem) {
  .jobs-revamp--modern .jobs-nav-grid,
  .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .jobs-revamp--modern .jobs-status-tabs {
    justify-self: stretch;
  }

  .jobs-revamp--modern .jobs-toggle-group,
  .jobs-revamp--modern .segmented-control {
    width: 100%;
  }
}

@media (max-width: 48rem) {
  .jobs-revamp--modern {
    padding: 0;
  }

  .jobs-revamp--modern .jobs-nav-grid,
  .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: 1fr;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .jobs-revamp--modern .jobs-filter-panel,
  .jobs-revamp--modern .jobs-table-card {
    margin-left: 0;
    margin-right: 0;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table {
    min-width: 0 !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table thead {
    display: none;
  }

  .jobs-revamp--modern #jobsTable table.v-table,
  .jobs-revamp--modern #jobsTable table.v-table tbody,
  .jobs-revamp--modern #jobsTable table.v-table tr,
  .jobs-revamp--modern #jobsTable table.v-table td {
    display: block;
    width: 100% !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody tr {
    border: 1px solid var(--jobs-border);
    border-radius: 0.75rem;
    box-shadow: 0 0.75rem 1.5rem rgba(26, 25, 22, 0.08);
    margin-bottom: 0.75rem;
    overflow: hidden;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td {
    border: 0 !important;
    border-bottom: 1px solid #f0eee8 !important;
    border-radius: 0 !important;
    display: grid;
    gap: 0.75rem;
    grid-template-columns: minmax(7rem, 0.4fr) minmax(0, 1fr);
    height: auto;
    min-height: 0;
    padding: 0.75rem !important;
    text-align: left !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td::before {
    color: var(--jobs-muted);
    content: attr(data-label);
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td:first-child {
    border-left: 0 !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td:last-child {
    border-bottom: 0 !important;
  }

  .jobs-revamp--modern .jobs-comments-column,
  .jobs-revamp--modern .jobs-comments-column .oms-comment-cell {
    justify-content: flex-start;
    text-align: left !important;
  }
}

/* Final Jobs-page guards for compact scroll and comments. */
#nav .jobs-revamp--modern {
  padding: 0 !important;
}

#nav .jobs-revamp--modern .jobs-nav-grid {
  gap: 0.5rem;
  padding: 0.5rem var(--oms-list-section-x, 30px) !important;
}

#nav .jobs-revamp--modern .jobs-stats-grid {
  gap: 0.5rem;
  padding: 0.625rem var(--oms-list-section-x, 30px) !important;
}

#nav .jobs-revamp--modern .jobs-stat-card {
  min-height: 4.875rem;
  padding: 0.8125rem 0.875rem 0.75rem 3.25rem;
}

#nav .jobs-revamp--modern .jobs-stat-icon {
  height: 2rem;
  left: 0.875rem;
  top: 0.875rem;
  width: 2rem;
}

#nav .jobs-revamp--modern .jobs-filter-panel {
  padding: 0.625rem 0.75rem !important;
}

#nav .jobs-revamp--modern .jobs-filter-field--search,
#nav .jobs-revamp--modern .oms-filter-board__field--search {
  flex: 1 1 15rem !important;
  min-width: 14rem;
}

#nav .jobs-revamp--modern .jobs-filter-panel .v-input__slot,
#nav .jobs-revamp--modern .jobs-filter-panel .e-input-group {
  height: var(--oms-filter-control-height, 2.625rem) !important;
  min-height: var(--oms-filter-control-height, 2.625rem) !important;
}

#nav .jobs-revamp--modern .jobs-table-card.oms-list-table-card {
  overflow: hidden !important;
  overflow-y: visible !important;
  padding-bottom: 1.5rem !important;
}

#nav .jobs-revamp--modern .jobs-table-scroll {
  max-width: 100%;
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

#nav .jobs-revamp--modern #jobsTable .v-table__overflow {
  overflow-x: hidden !important;
  overflow-y: visible !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table {
  min-width: 100% !important;
  table-layout: fixed !important;
  width: 100% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table thead th,
#nav .jobs-revamp--modern #jobsTable table.v-table tbody td {
  box-sizing: border-box;
  overflow: hidden !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table thead th {
  font-size: 0.6875rem !important;
  line-height: 1.15;
  overflow-wrap: normal;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  white-space: normal !important;
  word-break: normal;
}

#nav .jobs-revamp--modern #jobsTable table.v-table tbody td {
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(1),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(1) {
  width: 8% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(2),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(2) {
  width: 7% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(3),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(3) {
  width: 14% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(4),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(4) {
  text-align: center !important;
  width: 6% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(5),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(5) {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
  text-align: center !important;
  width: 8% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(6),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(6) {
  text-align: center !important;
  width: 18% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(7),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(7) {
  width: 9% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(8),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(8) {
  width: 8% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(9),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(9) {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
  text-align: center !important;
  width: 7% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(10),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(10) {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
  text-align: center !important;
  width: 5% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(9) .track-ass-btn {
  margin-left: auto !important;
  margin-right: auto !important;
  min-width: 5.75rem !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(10) {
  white-space: normal !important;
}

#nav .jobs-revamp--modern .jobs-route-combined-cell {
  min-width: 0;
  text-align: center !important;
  vertical-align: middle !important;
}

#nav .jobs-revamp--modern .jobs-route-pair {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 0.1875rem;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  min-width: 0;
  position: relative;
}

#nav .jobs-revamp--modern .jobs-route-pair::before {
  display: none;
}

#nav .jobs-revamp--modern .jobs-route-point {
  background: transparent;
  border: 0;
  border-radius: 0;
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  align-items: center;
  min-width: 0;
  padding: 0;
  position: relative;
  text-align: center;
  width: 100%;
}

#nav .jobs-revamp--modern .jobs-route-point::before {
  display: none;
}

#nav .jobs-revamp--modern .jobs-route-point--destination::before {
  background: #2563eb;
  border-color: #eff6ff;
  box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.22);
}

#nav .jobs-revamp--modern .jobs-route-point span {
  background: transparent;
  border-radius: 0;
  color: var(--jobs-muted);
  display: block;
  font-size: 0.6875rem;
  font-weight: 800;
  line-height: 1.2;
  padding: 0;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}

#nav .jobs-revamp--modern .jobs-route-point strong {
  display: -webkit-box;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 1.25;
  max-height: 2.45em;
  text-align: center;
  overflow: hidden;
  overflow-wrap: normal;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(8),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(8) {
  overflow: visible !important;
}

#nav .jobs-revamp--modern .jobs-customer-cell strong,
#nav .jobs-revamp--modern .jobs-customer-cell span,
#nav .jobs-revamp--modern .jobs-progress-head strong,
#nav .jobs-revamp--modern .jobs-progress-head span {
  overflow: hidden;
  text-overflow: ellipsis;
}

#nav .jobs-revamp--modern .jobs-status-pill {
  align-items: center;
  display: inline-flex;
  font-size: 0.6875rem;
  justify-content: center;
  line-height: 1.15;
  max-width: 100%;
  min-height: 1.75rem;
  overflow: visible !important;
  padding: 0.25rem 0.375rem;
  text-align: center;
  text-overflow: clip;
  white-space: normal !important;
  word-break: normal;
}

#nav .jobs-revamp--modern .jobs-id-cell,
#nav .jobs-revamp--modern .jobs-id-row {
  max-width: 100%;
  min-width: 0;
}

#nav .jobs-revamp--modern .jobs-id-row {
  gap: 0.375rem;
  overflow: visible;
}

#nav .jobs-revamp--modern .jobs-id-row > div {
  flex: 0 0 auto;
}

#nav .jobs-revamp--modern .jobs-id-cell strong {
  display: inline-block;
  flex: 0 1 auto;
  font-size: 0.875rem;
  line-height: 1.2;
  min-width: 0;
  overflow: visible;
  text-overflow: clip;
  white-space: nowrap;
}

#nav .jobs-revamp--modern .jobs-comments-column {
  overflow: visible !important;
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
  position: relative;
  text-align: center !important;
}

#nav .jobs-revamp--modern .jobs-comments-column .oms-comment-cell {
  gap: 0;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  max-width: 2.5rem;
  min-height: 2rem;
  position: relative;
  width: auto;
}

#nav
  .jobs-revamp--modern
  .jobs-comments-column
  .oms-comment-cell__text--empty {
  display: none !important;
}

#nav
  .jobs-revamp--modern
  .jobs-comments-column
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
  background: var(--jobs-panel);
  border: 1px solid var(--jobs-border);
  border-radius: 8px;
  box-shadow: 0 0.75rem 1.75rem rgba(15, 23, 42, 0.16);
  color: var(--jobs-ink);
  display: block !important;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.35;
  max-width: 18rem;
  min-width: 10rem;
  opacity: 0;
  padding: 0.5rem 0.625rem;
  pointer-events: none;
  position: absolute;
  right: calc(100% + 0.5rem);
  text-align: left;
  top: 50%;
  transform: translate(0.25rem, -50%);
  transition: opacity 0.15s ease, transform 0.15s ease;
  white-space: normal;
  z-index: 12;
}

#nav
  .jobs-revamp--modern
  .jobs-comments-column:hover
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty),
#nav
  .jobs-revamp--modern
  .jobs-comments-column:focus-within
  .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
  opacity: 1;
  pointer-events: auto;
  transform: translate(0, -50%);
}

@media (max-width: 90rem) {
  /* The view and status tabs keep their natural width here, like the
     Assignment view; they only stretch once the bar wraps (80rem). */
  #nav .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  #nav .jobs-revamp--modern .jobs-filter-field {
    flex: 1 1 13rem !important;
  }
}

@media (max-width: 48rem) {
  #nav .jobs-revamp--modern .jobs-nav-grid,
  #nav .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: 1fr !important;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  #nav .jobs-revamp--modern .jobs-filter-panel,
  #nav .jobs-revamp--modern .jobs-table-card {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  #nav .jobs-revamp--modern .jobs-filter-field,
  #nav .jobs-revamp--modern .oms-filter-board__field {
    flex: 1 1 100% !important;
    min-width: 0;
  }

  #nav .jobs-revamp--modern .jobs-id-row {
    justify-content: flex-start;
  }

  #nav .jobs-revamp--modern #jobsTable table.v-table th:last-child,
  #nav .jobs-revamp--modern #jobsTable table.v-table td:last-child {
    max-width: none !important;
    min-width: 0 !important;
    width: 100% !important;
  }

  #nav
    .jobs-revamp--modern
    .jobs-comments-column
    .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
    left: 0;
    max-width: calc(100vw - 4rem);
    right: auto;
    top: calc(100% + 0.375rem);
    transform: translateY(-0.25rem);
  }

  #nav
    .jobs-revamp--modern
    .jobs-comments-column:hover
    .oms-comment-cell__text:not(.oms-comment-cell__text--empty),
  #nav
    .jobs-revamp--modern
    .jobs-comments-column:focus-within
    .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
    transform: translateY(0);
  }
}

/* Final Jobs list alignment: keep stat cards horizontal and fit the short table. */
#nav .jobs-revamp--modern .jobs-stats-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}

#nav .jobs-revamp--modern .jobs-table-card.oms-list-table-card,
#nav .jobs-revamp--modern .jobs-table-scroll,
#nav .jobs-revamp--modern #jobsTable .v-table__overflow {
  overflow-x: auto !important;
  overflow-y: visible !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table {
  min-width: var(--oms-list-table-min-width, 100%) !important;
  table-layout: fixed !important;
  width: 100% !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(1),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(1) {
  width: var(--oms-list-col-1, 8%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(2),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(2) {
  width: var(--oms-list-col-2, 7%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(3),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(3) {
  width: var(--oms-list-col-3, 14%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(4),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(4) {
  width: var(--oms-list-col-4, 6%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(5),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(5) {
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
  text-align: center !important;
  width: var(--oms-list-col-5, 8%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(6),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(6) {
  text-align: center !important;
  width: var(--oms-list-col-6, 18%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(7),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(7) {
  width: var(--oms-list-col-7, 9%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(8),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(8) {
  width: var(--oms-list-col-8, 8%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(9),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(9) {
  width: var(--oms-list-col-9, 7%) !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(10),
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(10) {
  width: var(--oms-list-col-10, 5%) !important;
}

@media (max-width: 64rem) {
  #nav .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 48rem) {
  #nav .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: 1fr !important;
  }
}

/* Fit dense values inside the existing Jobs table columns. */
#nav .jobs-revamp--modern #jobsTable table.v-table thead th:nth-child(1),
#nav .jobs-revamp--modern #jobsTable table.v-table thead th:nth-child(9),
#nav .jobs-revamp--modern #jobsTable table.v-table thead th:nth-child(10) {
  font-size: clamp(0.5625rem, 0.5vw, 0.6875rem) !important;
  line-height: 1.05;
  overflow: visible !important;
  padding-left: 0.1875rem !important;
  padding-right: 0.1875rem !important;
  text-align: center !important;
  white-space: normal !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table tbody td:nth-child(1),
#nav .jobs-revamp--modern #jobsTable table.v-table tbody td:nth-child(9),
#nav .jobs-revamp--modern #jobsTable table.v-table tbody td:nth-child(10) {
  overflow: visible !important;
  padding-left: 0.25rem !important;
  padding-right: 0.25rem !important;
}

#nav .jobs-revamp--modern .jobs-id-row {
  align-items: center;
  display: flex;
  gap: 0.25rem;
  justify-content: flex-start;
}

#nav .jobs-revamp--modern .jobs-id-row > div,
#nav .jobs-revamp--modern .jobs-id-row .v-btn,
#nav .jobs-revamp--modern .jobs-id-row button {
  flex: 0 0 auto;
  height: 1.875rem !important;
  margin: 0 !important;
  min-width: 1.875rem !important;
  width: 1.875rem !important;
}

#nav .jobs-revamp--modern .jobs-id-value,
#nav .jobs-revamp--modern .jobs-id-cell strong {
  flex: 1 1 auto;
  font-size: clamp(0.625rem, 0.54vw, 0.8125rem) !important;
  line-height: 1.1;
  max-width: 100%;
  min-width: 0;
  overflow: hidden !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(9) .track-ass-btn {
  align-items: center;
  display: inline-flex !important;
  font-size: clamp(0.625rem, 0.5vw, 0.6875rem) !important;
  gap: 0.25rem;
  justify-content: center;
  line-height: 1 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 100%;
  min-height: 2rem !important;
  min-width: 0 !important;
  padding: 0 0.5rem !important;
  white-space: nowrap !important;
  width: auto !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(9) .track-ass-btn .v-icon {
  font-size: 0.875rem !important;
  margin-right: 0.1875rem !important;
}

#nav .jobs-revamp--modern .jobs-comments-column .oms-comment-cell {
  max-width: 100%;
}

#nav .jobs-revamp--modern .jobs-comments-column .oms-comment-cell__action,
#nav .jobs-revamp--modern .jobs-comments-column .jobs-comment-action {
  max-width: 2rem;
  min-width: 2rem;
}

/* Match the Assignment view: both tab groups keep their natural width, view
   tabs on the left and status tabs on the right. Below 80rem the shared list
   rules stretch them, on both pages. */
@media (min-width: 80.0625rem) {
  #nav .jobs-revamp--modern .jobs-nav-grid {
    grid-template-columns: minmax(0, max-content) minmax(0, 1fr) !important;
  }

  #nav .jobs-revamp--modern .jobs-nav-grid .jobs-toggle-group {
    justify-self: start;
    max-width: 100%;
    width: fit-content !important;
  }

  #nav .jobs-revamp--modern .jobs-nav-grid .jobs-status-tabs {
    justify-self: end;
  }
}
</style>

<style scoped>
.wrapper {
  max-width: 450px;
  margin: 0 auto;
}
.total.avatar .count {
  background-color: darkorange;
  color: white !important;
  padding: 0 5px;
  font-size: 18px !important;
  border-radius: 5px;
  margin-left: 10px;
}
.total.avatar {
  min-width: 280px !important;
  height: 50px !important;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  border-radius: 0;
}
.tab {
  margin-bottom: 20px;
}
.total.avatar span {
  color: darkorange !important;
}
.track-ass-btn[data-v-3cb02aee] {
  text-decoration: none;
  color: #ffffff;
  background-color: #ffc278;
  border-radius: 5px;
  border: 2px solid darkorange;
  padding: 2px 5px;
  margin-right: 5px;
}

.change table.v-table tbody tr {
  background-color: forestgreen;
}
.status-count {
  font-size: 16px;

  font-weight: 900 !important;
}
.reset-btn {
  float: right;
  margin-top: 6px;
}
.avatar {
  border-radius: 10px;
}
.viewDetail {
  cursor: pointer;
}
.job-detail {
  margin: auto 0;
}
.theme--light.menuable__content__active {
  min-width: 290px !important;
}
.tooltip {
  font-size: 13px;
  width: auto !important;
  font-weight: 500;
}
.tooltip-op {
  opacity: 1 !important;
}
.text-center {
  text-align: center !important;
}

.date-picker {
  min-width: 100%;
}

.page-count-span {
  float: right;
  margin-top: 26px;
  color: darkorange;
}
.track-ass-btn {
  text-decoration: none;
  color: #ffffff;
  background-color: #ffc278;
  border-radius: 5px;
  border: 2px solid darkorange;
  padding: 2px 5px;
}
.reset-btn-color {
  background-color: #ffe7c9 !important;
}
.red-button {
  border-radius: 5px;
  background-color: #ff7b7b !important;
  color: #ffffff !important;
  border: 2px solid red !important;
  padding: 2px 10px;
}
.blue-button {
  border-radius: 5px;
  background-color: rgb(0, 140, 255) !important;
  color: #ffffff !important;
  border: 2px solid rgb(0, 140, 255) !important;
  padding: 2px 10px;
}
.gray-button {
  border-radius: 5px;
  background-color: #bdc3c7 !important;
  color: #ffffff !important;
  border: 2px solid #bdc3c7 !important;
  padding: 2px 10px;
}
.p-16 {
  padding: 0 16px !important;
}
.p-b-0 {
  padding-bottom: 0 !important;
}

.colorchange {
  background-color: #fae3e3 !important;
}
.colorchangeyellow {
  background-color: #ffffe0 !important;
}
.cancel-btn {
  text-decoration: none;
  color: #ffffff;
  border: 2px solid red;
  padding: 2px;
  margin-top: 5px;
  background-color: #f38282;
  border-radius: 5px;
}
.m-t-10 {
  margin-top: 10px;
}

.filter {
  padding: 20px;
  margin: 0 auto;
}
.reset {
  margin-top: 10px;
}
.gap {
  position: relative;
  right: 2px;
  bottom: 2px;
  z-index: auto;
}
.reset-btn-color {
  background-color: #ffe7c9 !important;
}
.v-datatable thead th.column.sortable .v-icon {
  opacity: 0.3 !important;
}

.jobs-revamp .jobs-filter-field,
.jobs-revamp .jobs-filter-date,
.jobs-revamp .jobs-filter-actions {
  margin: 0 !important;
  max-width: none !important;
  min-height: 42px;
  padding: 0 !important;
  width: 100% !important;
}

.jobs-revamp .jobs-filter-panel .gap {
  bottom: auto !important;
  position: static !important;
  right: auto !important;
}

.jobs-revamp .jobs-filter-panel .jobs-reset-link {
  height: 42px;
}

/* Ongoing queue sizing and responsive overrides. Keep these scoped to Jobs. */
.jobs-revamp--modern .jobs-nav-grid,
.jobs-revamp--modern .jobs-stats-grid,
.jobs-revamp--modern .jobs-filter-panel,
.jobs-revamp--modern .jobs-table-card {
  max-width: 100%;
  min-width: 0;
}

.jobs-revamp--modern .jobs-nav-grid {
  grid-template-columns: var(
    --oms-list-nav-columns,
    minmax(0, max-content) minmax(0, 1fr)
  );
}

.jobs-revamp--modern .jobs-status-tabs {
  justify-self: end;
}

.jobs-revamp--modern .jobs-table-card {
  overflow-x: auto;
  overflow-y: visible;
}

.jobs-revamp--modern #jobsTable .v-table__overflow {
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

.jobs-revamp--modern #jobsTable table.v-table {
  min-width: var(--oms-list-table-min-width, 96rem) !important;
  width: 100%;
}

.jobs-revamp--modern #jobsTable table.v-table thead th,
.jobs-revamp--modern #jobsTable table.v-table tbody td {
  box-sizing: border-box;
  line-height: 1.35;
  overflow-wrap: normal !important;
  vertical-align: middle;
  word-break: normal !important;
}

.jobs-revamp--modern #jobsTable table.v-table tbody td {
  height: 4.25rem;
  padding: 0.625rem 0.75rem !important;
}

.jobs-revamp--modern #jobsTable table.v-table tbody td + td,
.jobs-revamp--modern #jobsTable table.v-table thead th + th {
  border-left: 0.375rem solid transparent !important;
  background-clip: padding-box;
}

.jobs-revamp--modern #jobsTable table.v-table thead th {
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}

.jobs-revamp--modern #jobsTable table.v-table th:nth-child(4),
.jobs-revamp--modern #jobsTable table.v-table td:nth-child(4) {
  text-align: center !important;
}

.jobs-revamp--modern .jobs-customer-cell,
.jobs-revamp--modern .jobs-route-point,
.jobs-revamp--modern .oms-comment-cell {
  min-width: 0;
  width: 100%;
}

.jobs-revamp--modern .jobs-customer-cell strong,
.jobs-revamp--modern .jobs-customer-cell span,
.jobs-revamp--modern .jobs-route-point strong,
.jobs-revamp--modern .oms-comment-cell__text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jobs-revamp--modern .jobs-route-point strong {
  overflow-wrap: normal;
}

.jobs-revamp--modern .jobs-route-pair {
  gap: 0.25rem;
}

#nav .jobs-revamp--modern #jobsTable table.v-table th.jobs-route-header,
#nav .jobs-revamp--modern #jobsTable table.v-table th:nth-child(6),
#nav .jobs-revamp--modern #jobsTable table.v-table td.jobs-route-column,
#nav .jobs-revamp--modern #jobsTable table.v-table td:nth-child(6) {
  text-align: center !important;
}

#nav .jobs-revamp--modern #jobsTable table.v-table td.jobs-route-column {
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}

#nav .jobs-revamp--modern .jobs-route-column .jobs-route-pair {
  align-items: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 14rem;
}

#nav .jobs-revamp--modern .jobs-route-column .jobs-route-pair::before,
#nav .jobs-revamp--modern .jobs-route-column .jobs-route-point::before {
  display: none !important;
}

#nav .jobs-revamp--modern .jobs-route-column .jobs-route-point {
  align-items: center !important;
  padding-left: 0 !important;
  text-align: center !important;
}

#nav .jobs-revamp--modern .jobs-route-column .jobs-route-point span,
#nav .jobs-revamp--modern .jobs-route-column .jobs-route-point strong {
  text-align: center !important;
}

.jobs-revamp--modern .jobs-progress-cell {
  align-items: stretch;
  gap: 0.25rem;
  min-width: 0;
}

.jobs-revamp--modern .jobs-progress-head {
  align-items: baseline;
  flex-wrap: nowrap;
}

.jobs-revamp--modern .jobs-progress-head strong,
.jobs-revamp--modern .jobs-progress-head span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jobs-revamp--modern .jobs-progress-cell .v-btn,
.jobs-revamp--modern .jobs-progress-cell button {
  align-self: flex-start;
  margin-top: 0.125rem !important;
}

.jobs-revamp--modern .jobs-progress-cell .log {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.125rem;
}

.jobs-revamp--modern .jobs-progress-cell .view-ass-btn {
  align-self: flex-start;
  min-height: 1.75rem !important;
  padding: 0 0.625rem !important;
}

.jobs-revamp--modern .jobs-status-pill,
.jobs-revamp--modern .track-ass-btn,
.jobs-revamp--modern .jobs-assignment-total,
.jobs-revamp--modern .jobs-country-pill {
  white-space: nowrap;
}

.jobs-revamp--modern .jobs-country-pill {
  max-width: 100%;
  overflow: hidden;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-overflow: ellipsis;
}

.jobs-revamp--modern .jobs-status-pill {
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.jobs-revamp--modern .jobs-comments-column {
  text-align: center !important;
}

.jobs-revamp--modern .jobs-comments-column .oms-comment-cell {
  align-items: center;
  justify-content: center;
}

.jobs-revamp--modern .jobs-comments-column .oms-comment-cell__text--empty {
  display: none;
}

.jobs-revamp--modern .jobs-comments-column .oms-comment-cell__text:not(.oms-comment-cell__text--empty) {
  display: none;
}

.jobs-revamp--modern .jobs-comment-action {
  margin-top: 0;
}

@media (max-width: 80rem) {
  .jobs-revamp--modern .jobs-nav-grid,
  .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .jobs-revamp--modern .jobs-status-tabs {
    justify-self: stretch;
  }

  .jobs-revamp--modern .jobs-toggle-group,
  .jobs-revamp--modern .segmented-control {
    width: 100%;
  }
}

@media (max-width: 48rem) {
  .jobs-revamp--modern {
    padding: 0;
  }

  .jobs-revamp--modern .jobs-nav-grid,
  .jobs-revamp--modern .jobs-stats-grid {
    grid-template-columns: 1fr;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .jobs-revamp--modern .jobs-filter-panel,
  .jobs-revamp--modern .jobs-table-card {
    margin-left: 0;
    margin-right: 0;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table {
    min-width: 0 !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table thead {
    display: none;
  }

  .jobs-revamp--modern #jobsTable table.v-table,
  .jobs-revamp--modern #jobsTable table.v-table tbody,
  .jobs-revamp--modern #jobsTable table.v-table tr,
  .jobs-revamp--modern #jobsTable table.v-table td {
    display: block;
    width: 100% !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody tr {
    border: 1px solid var(--jobs-border);
    border-radius: 0.75rem;
    box-shadow: 0 0.75rem 1.5rem rgba(26, 25, 22, 0.08);
    margin-bottom: 0.75rem;
    overflow: hidden;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td {
    border: 0 !important;
    border-bottom: 1px solid #f0eee8 !important;
    border-radius: 0 !important;
    display: grid;
    gap: 0.75rem;
    grid-template-columns: minmax(7rem, 0.4fr) minmax(0, 1fr);
    height: auto;
    min-height: 0;
    padding: 0.75rem !important;
    text-align: left !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td::before {
    color: var(--jobs-muted);
    content: attr(data-label);
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td:first-child {
    border-left: 0 !important;
  }

  .jobs-revamp--modern #jobsTable table.v-table tbody td:last-child {
    border-bottom: 0 !important;
  }

  .jobs-revamp--modern .jobs-comments-column,
  .jobs-revamp--modern .jobs-comments-column .oms-comment-cell {
    justify-content: flex-start;
    text-align: left !important;
  }
}

/* Final filter-board alignment override for the Jobs page. */
.jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__grid {
  align-items: start !important;
  display: grid !important;
  gap: 0.75rem !important;
  grid-template-columns:
    minmax(0, 0.85fr)
    minmax(0, 1.35fr)
    minmax(0, 0.95fr)
    minmax(0, 1.25fr)
    minmax(0, 1fr)
    minmax(0, 1fr)
    minmax(6.75rem, 0.65fr) !important;
}

.jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__field,
.jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__actions,
.jobs-revamp--modern .jobs-filter-panel ::v-deep .jobs-filter-field,
.jobs-revamp--modern .jobs-filter-panel ::v-deep .jobs-filter-date,
.jobs-revamp--modern .jobs-filter-panel ::v-deep .jobs-filter-actions {
  align-self: start !important;
  grid-column: auto !important;
  height: var(--oms-filter-control-height, 2.625rem) !important;
  margin: 0 !important;
  min-height: var(--oms-filter-control-height, 2.625rem) !important;
  min-width: 0 !important;
  padding: 0 !important;
}

.jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__field--search {
  grid-column: auto !important;
}

.jobs-revamp--modern .jobs-filter-panel ::v-deep .jobs-filter-actions {
  align-items: stretch !important;
  display: flex !important;
  justify-content: stretch !important;
}

.jobs-revamp--modern .jobs-filter-panel ::v-deep .jobs-reset-link,
.jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__reset {
  height: var(--oms-filter-control-height, 2.625rem) !important;
  min-height: var(--oms-filter-control-height, 2.625rem) !important;
  width: 100% !important;
}

@media (max-width: 90rem) {
  .jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__grid {
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 64rem) {
  .jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 40rem) {
  .jobs-revamp--modern .jobs-filter-panel ::v-deep .oms-filter-board__grid {
    grid-template-columns: 1fr !important;
  }
}
</style>
